import React, { Component } from "react";
import axios from "axios";
import { apiUrl } from "../../config/config";
import classnames from "classnames";
import $, { event } from "jquery";
import socketIOClient from "socket.io-client";
import { MDBDataTable } from "mdbreact";
import ProgressBtn from "../../components/common/ProgressButton";
import TopNav from "../../components/common/TopNav";
import SideBar from "../../components/common/SideBar";
import LiveTag from "../../components/common/LiveTag";
import { livePatientsEnabled } from "../../config/config";
import AddModalComplete from "../verifier/AddModalComplete";
import Dropdown from "react-dropdown";
import "react-dropdown/style.css";
import Select from "react-select";
import AddModalReport from "./AddModalReport";
import EcgStripsModal from "./EcgStripsModal";
import { format, parseISO } from "date-fns";
import "./patient-list.css";
import Countdown from "react-countdown";

import LinearProgress from "@material-ui/core/LinearProgress";
// eslint-disable-next-line import/no-webpack-loader-syntax
import Worker from "worker-loader!./worker.js";
import { duration } from "@material-ui/core";
import { Pointer, time } from "highcharts";
import Datetime from "react-datetime";
import "react-datetime/css/react-datetime.css";
import moment from "moment";
import { ColumnSizing } from "@tanstack/react-table";
import url from "socket.io-client/lib/url";
import { Toaster, toast } from "react-hot-toast";

// Live progress socket disabled — re-enable once the backend at
// https://web.mybiocalculus.com:5000 has CORS configured for cross-origin
// credentialed requests. ProgressButton handles socket === null gracefully.
// const socket = socketIOClient("https://web.mybiocalculus.com:5000");
const socket = null;

// Build the ETA tooltip string.
//
// Backend contract (post-patch):
//   avgVerifySeconds → mean of per-verifier averages on this patient
//                      (= the "Avg / file" reviewers see in the modal)
//   parallelism      → distinct verifiers who have verified this patient
//                      (informational; ETA does NOT divide by it)
//   etaMinutes       → pending × avgVerifySeconds, in minutes
//
// ETA is shown only when at least one verifier has marked at least one
// verify on this patient — handled on the backend by returning
// etaMinutes = 0 in the no-data case.
function buildEtaTooltip(eta) {
  if (!eta) return "";
  const pending = eta.pendingFiles || 0;
  const perVerifier = Number(eta.avgVerifySeconds) || 0;
  const perVerifierMin = (perVerifier / 60).toFixed(1);

  const parts = [`${pending} pending`];
  if (perVerifier > 0) {
    if (eta.parallelism > 1) {
      parts.push(
        `${eta.parallelism} verifiers · mean ~${perVerifierMin} min/file`
      );
    } else {
      parts.push(`~${perVerifierMin} min/file`);
    }
  }
  if (eta.speedSource === "patient+slowdown") {
    parts.push("slowdown applied");
  }
  return parts.join(" · ");
}

const customStyles = {
  root: {
    display: "flex",
    alignItems: "center",
  },
  wrapper: {
    margin: "10px",
    position: "relative",
  },
  linearProgress: {
    position: "absolute",
    top: 0,
    width: "100%",
    height: "100%",
    opacity: 0.4,
    borderRadius: 4,
  },
};

// Resolves the priority for a patient. `patient.priority` is the single
// source of truth — no fallback to deviceInfo.priority: devices get
// physically reused across patients over time, so that field can carry a
// stale priority forward from whichever patient had the device before.
const getPatientPriority = (patient) => {
  if (!patient) return 4;
  const p = patient.priority;
  if (p !== undefined && p !== null && p !== "") {
    const n = Number(p);
    if (Number.isFinite(n) && n > 0) return n;
  }
  return 4;
};

// Rank used for queue ordering: only a priority actually assigned through
// the "Priority" popup counts (High=1, Moderate=2, Simple=3). Normal (4) is
// the default and means "no priority" — such rows sort by upload time only.
const assignedPriorityRank = (patient) => {
  const p = getPatientPriority(patient);
  return p >= 1 && p <= 3 ? p : 99;
};

// Upload / confirm time as a comparable number. Both fields are stored as
// IST wall-clock (ConfirmupdatedDate "YYYY-MM-DDTHH:MM:SS(.sss)Z",
// updatedDate "YYYY-MM-DD HH:MM:SS") — read the wall-clock digits directly
// so the two never skew against each other by a timezone offset.
const uploadTimeMs = (patient) => {
  const raw = (patient && (patient.ConfirmupdatedDate || patient.updatedDate)) || "";
  const m = String(raw).match(/(\d{4})-(\d{2})-(\d{2})[T ](\d{2}):(\d{2})(?::(\d{2}))?/);
  if (!m) return Number.MAX_SAFE_INTEGER; // no upload yet → bottom
  return Date.UTC(+m[1], +m[2] - 1, +m[3], +m[4], +m[5], +(m[6] || 0));
};

class PatientList extends Component {
  constructor() {
    super();
    const menus = [
      { title: "Verifier Home", url: "/verifier-home" },
      { title: "Patient list", url: "/patient-list" },
      { title: "Labled Patients", url: "/labled-patients" },
      { title: "Verified", url: "/verification-completed" },

    ];
    if (localStorage.getItem("verifiertype") === "8") {
      menus.splice(2, 0, { title: "Patient-hold", url: "/patient-hold" });
      menus.push({ title: "Add Accounts", url: "/add-accounts" });
    }
    if (localStorage.getItem("AdminUser") === "8") {
      menus.splice(3, 0, { title: "Device Details", url: "/device-details" });
      menus.splice(4, 0, { title: "Battery Issue", url: "/battery-issue" });
    }

    if (localStorage.getItem("verifiertype") === "8") {
      menus.splice(4, 0, { title: "Support Home", url: "/support-home" });
    }
    if (localStorage.getItem("verifiertype") === "8") {
      menus.splice(5, 0, { title: "QC Home", url: "/qc_home" });
    }
    if (localStorage.getItem("AdminUser") === "8") {
      menus.splice(6, 0, { title: "Report Shared", url: "/report-shared" });
    }
    if (localStorage.getItem("AdminUser") === "8") {
      menus.splice(6, 0, {
        title: "Supported Person",
        url: "/supported-persons",
      });

    }
    if (localStorage.getItem("AdminUser") === "8") {
      menus.splice(6, 0, {
        title: "Reset Password",
        url: "/ResetPassword",
      });
    }

    // Admin-only dashboards. Visible to both Admin (type 1) and
    // Admin Verifier (type 8) — matches the gate that used to live
    // inside SideBar.js before these were moved into the regular
    // dynamic menus prop. Appear as standard sidebar entries so
    // they render identically to Patient List etc.
    const _vt = localStorage.getItem("verifiertype");
    if (_vt === "8" || _vt === "1") {
      menus.push(
        { title: "Analysis Dashboard", url: "/analysis-dashboard" },
        { title: "Users by Role",      url: "/users-by-role" },
        { title: "Telemetry",          url: "/telemetry" },
        { title: "Assign Patients",    url: "/assign-patients" }
      );
    }

    // Restricted Verifier tier (type 10) only: a "Queue" link to this same
    // table/page, filtered (via ?queue=1, see filterRows) down to just the
    // patients actually assigned to this verifier.
    if (_vt === "10") {
      menus.splice(1, 0, { title: "Queue", url: "/patient-list?queue=1" });
    }

    this.state = {
      menus,
      newAssignmentAlerts: [],
      isModalCompleteOpen: false,
      profileLink: "verifier-profile",
      patients: [],
      nor_minhr: "",
      nor_maxhr: "",
      qtcformula: "",
      qtcvalue_min: "",
      qtcvaluemax: "",
      qrswidth_min: "",
      qrswidth_max: "",
      qrsamp_min: "",
      qrsamp_max: "",
      stelevation: "",
      pwidth_min: "",
      pwidth_max: "",
      pamp_min: "",
      pamp_max: "",
      stdepression: "",
      twidth_min: "",
      twidth_max: "",
      macid: "",
      tamp_min: "",
      tamp_max: "",
      printerval_min: "",
      printerval_max: "",
      tachyhr_lower: "",
      tachyhr_upper: "",
      bradyhr_lower: "",
      bradyhr_upper: "",
      pauselength: "",
      graph_gen: "",
      errors: {},
      userid: "",
      smoking: "",
      diabetes: "",
      height: "",
      weight: "",
      hospital: "",
      phone: "",
      patient_name: "",
      email_id: "",
      dob: null,
      age: "", // Add age to state
      af: "",
      hyper_tension: "",
      hyper_lipidemia: "",
      indication: "",
      thyroid_function: "",
      cardiac_surgery: "",
      doctors: [],
      verifiers: [],
      selectedVerifierIds: [],
      selectedVerifiers: [],
      doctor_id: "",
      doctor_name: "Choose",
      doctors: [],
      selectedDoctor: null,
      searchTerm: "",
      data: {},
      prog_data: 0,
      loading: false,
      // socketNew: socket,
      patientDetails: null,
      ipop: "",
      priority: "4",
      verifiertype: "",
      allverifiers: "",
      reportstatus: "",
      isModalReportOpen: false,
      generatereportuserid: "",
      treemenu: [],
      duration: "",
      customer_details: "",
      customerId: "",        // selected customer's id (from getCustomerNames)
      customerList: [],      // [{ id, name }] — populated lazily when the edit modal opens
      stripsUserid: null,    // patient _id whose uploaded ECG images the popup shows (null = closed)
      showButton: true,
      refreshKey: 0,
      filetype: "",
      sortedPatients: [],
      selectedVerifiersEfficency: [],
      loadingVerifierProgress: false,
      hourstocompleted: "",
      gender: "",
      columns: [],
      rows: [],
      // patientId → { pendingFiles, avgVerifySeconds, etaSeconds, etaMinutes }
      // Filled by fetchData via /patientETA. Used to render the ETA column.
      etaMap: {},
      // patientId → block label ("day 1", "first hlf", ...) assigned to ME
      // specifically via the admin's Quick Assigner Notes. Informational.
      blockMap: {},
      myPatientIdSet: null,
      searchQuery: "",
      patientName: "",
      pacemaker: false,
      issueReport: "",
      Confirmation: "",
      blockReportOption: "",
      loadingEditModal: false, // Add loading state for edit modal
      // TAT notification tracking
      tatNotifications: new Set(), // Track which patients have been notified
      lastTatCheck: null, // Track last TAT check time
      isShowingNotification: false, // Track if a notification is currently being shown
      notificationQueue: [], // Queue for pending notifications
      statusFilter: "All",
      supportPersons: [], // list from API
      supportPerson: "", // selected support person id
      supportLevel: "",
      supportedMatter: "",
      prioritizeData: "No", // <-- Add this line for the new field
      clinicalCondition: "", // <-- Add this line for the new field
      // Priority modal state
      modalPatientId: null,
      modalMacid: null,
      modalPriority: "", // no default priority pre-selected
      modalDateTime: "",
      patientProgress: {}, // Track progress for each patient {patientId: {progress: value, isActive: true/false}}
      progressSnapshot: {}, // { [patientId]: { progress, lastUpdated } } — used to detect stuck analysis
      newComment: "", // new comment being typed (separate from existing comments history)
    };
    this.intervalId = null;
    // Request-sequence counter — fetchData() increments on every call and
    // each response handler only commits state if its captured sequence still
    // matches the latest. Drops out-of-order responses that would otherwise
    // overwrite fresh data with stale data (the cause of "performance not
    // updating properly").
    this._fetchSeq = 0;

    this.selectItem = this.selectItem.bind(this);
    this.getInfo = this.getInfo.bind(this);
    this.handleModalComplete = this.handleModalComplete.bind(this);
    this.resetModalComplete = this.resetModalComplete.bind(this);

    this.submitComment = this.submitComment.bind(this);
    this.preventDefault = this.preventDefault.bind(this);
    this.getConfirmTime = this.getConfirmTime.bind(this);
    this.HandleVerifiedSpeed = this.HandleVerifiedSpeed.bind(this);
    this.getverifiedprogress = this.getverifiedprogress.bind(this);
    this.onGenderChange = this.onGenderChange.bind(this);
    this.filterRows = this.filterRows.bind(this);
    this.handleSearchChange = this.handleSearchChange.bind(this);
    this.handleRowClick = this.handleRowClick.bind(this);
    this.navigateToPatient = this.navigateToPatient.bind(this);
  }

  // Utility to calculate age from DOB
  calculateAgeFromDOB(dob) {
    if (!dob) return "";
    const dobDate = new Date(dob);
    const today = new Date();
    let age = today.getFullYear() - dobDate.getFullYear();
    const m = today.getMonth() - dobDate.getMonth();
    if (m < 0 || (m === 0 && today.getDate() < dobDate.getDate())) {
      age--;
    }
    return age;
  }

  // Utility to calculate DOB from age
  calculateDOBFromAge(age) {
    if (!age || isNaN(age)) return "";
    const today = new Date();
    const dobYear = today.getFullYear() - age;
    // Set DOB to today's month and date for simplicity
    return new Date(dobYear, today.getMonth(), today.getDate())
      .toISOString()
      .slice(0, 10);
  }

  // When EditInfoModal opens, set age from DOB
  componentDidUpdate(prevProps, prevState) {
    if (this.state.isEditInfoModalOpen && !prevState.isEditInfoModalOpen) {
      if (this.state.dob) {
        const age = this.calculateAgeFromDOB(this.state.dob);
        if (age !== this.state.age) {
          this.setState({ age });
        }
      }
    }
  }

  // Age input change handler
  handleAgeChange = (e) => {
    const age = e.target.value;
    const dob = this.calculateDOBFromAge(age);
    this.setState({ age, dob });
  };

  componentWillUnmount() {
    // Clear the interval when the component unmounts
    clearInterval(this.intervalId);
  }
  fetchData = () => {
    const verifiertype = localStorage.getItem("verifiertype");
    this.setState({ verifiertype });

    function capitalizeFirstLetter(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    }

    // Only fetch doctors list once — it rarely changes
    if (!this._doctorsFetched) {
      this._doctorsFetched = true;
      const worker = new Worker();
      const newstat = this;
      worker.postMessage({
        name: "alldoctors",
        url: apiUrl + "api/users/alldoctors",
      });
      worker.addEventListener("message", function (event) {
        newstat.setState({ doctors: event.data });
      });
    }

    // Capture this call's sequence number. Any response from an earlier
    // call (i.e. seq < this._fetchSeq when the response arrives) is ignored.
    const mySeq = ++this._fetchSeq;
    if (livePatientsEnabled) this.loadRemoteMode();

    // Restricted Verifier tier (type 10) only: which rows in the (now
    // unscoped) list are actually mine — gates the "Full" block badge and
    // powers the "Queue" sidebar view's filter (see filterRows).
    if (verifiertype === "10") {
      axios
        .get(apiUrl + "api/users/myAssignedPatientIds")
        .then((res) => {
          const ids = (res.data && res.data.ids) || [];
          this.setState({ myPatientIdSet: new Set(ids) });
        })
        .catch(() => {
          this.setState({ myPatientIdSet: new Set() });
        });
    }

    axios
      .all([
        axios.get(apiUrl + "api/users/getVerifierPatientsPercentage"),
        axios.get(apiUrl + "api/users/allverifiers"),
        // Which day/half/quarter of a shared patient is mine — informational
        // only, shown as a badge next to the patient's name.
        axios.get(apiUrl + "api/users/myBlockAssignments").catch(() => ({ data: { blocks: {} } })),
      ])
      .then(
        axios.spread((patientsRes, verifiersRes, blocksRes) => {
          // Drop the response if a newer fetch has been kicked off since.
          if (mySeq !== this._fetchSeq) {
            return;
          }
          const filteredPatients = patientsRes.data.sortedPatients.filter(
            (patient) =>
              // /live-patients (mode="Live") is this same list for Confirmation
              // "Live" patients — same steps, kept apart from the Holter list.
              this.props.mode === "Live"
                ? patient.Confirmation === "Live"
                : patient.Confirmation === "Yes" || patient.Confirmation === "No"
          );

          // Fetch ETA only for the visible/filtered patients — passing all
          // 40k+ patient IDs would be wasteful. Failure tolerant.
          const visibleIds = filteredPatients
            .map((p) => p && p._id)
            .filter(Boolean)
            .map(String);

          const etaPromise =
            visibleIds.length > 0
              ? axios
                  .get(
                    apiUrl +
                      "api/users/patientETA?patientIds=" +
                      encodeURIComponent(visibleIds.join(","))
                  )
                  .then((r) => r.data)
                  .catch(() => ({ patients: [] }))
              : Promise.resolve({ patients: [] });

          etaPromise.then((etaData) => {
            // Re-check the seq guard now that we've awaited a second hop.
            if (mySeq !== this._fetchSeq) return;

            const etaMap = {};
            for (const e of (etaData && etaData.patients) || []) {
              if (e && e.patientId) etaMap[String(e.patientId)] = e;
            }

            this.setState(
              {
                patients: filteredPatients,
                allverifiers: verifiersRes.data,
                etaMap,
                blockMap: (blocksRes && blocksRes.data && blocksRes.data.blocks) || {},
              },
            () => {
              // console.log("patients!!!!!!!!!!!!!", this.state.patients);
              // Ordering (upload-time queue):
              //   1. pending work (report_status 0 / 2 / 6) above finished
              //      rows — not a priority rule, keeps done reports off
              //      the top of the queue.
              //   2. patients that were given a priority through the
              //      "Priority" popup (High=1 → Moderate=2 → Simple=3).
              //      Normal (4) / unset is NOT a priority — no effect.
              //   3. upload time, oldest first (ConfirmupdatedDate when the
              //      partner confirmed, else the device's updatedDate).
              // The old priority-driven TAT ("time left") ordering and the
              // Prioritize Yes/No flag no longer influence the order.
              const sortedPatients = this.state.patients
                .slice()
                .sort((a, b) => {
                  const statusOrder = { 0: 1, 2: 1, 6: 1 };
                  const aStatus = statusOrder[a.report_status] || 99;
                  const bStatus = statusOrder[b.report_status] || 99;
                  if (aStatus !== bStatus) return aStatus - bStatus;

                  const aPr = assignedPriorityRank(a);
                  const bPr = assignedPriorityRank(b);
                  if (aPr !== bPr) return aPr - bPr;

                  return uploadTimeMs(a) - uploadTimeMs(b);
                });

              const data = {
                columns: [
                  { label: "SL NO", field: "slno", sort: "asc", width: 0.5 },
                  {
                    label: "PATIENT",
                    field: "patientId",
                    sort: "asc",
                    width: 7,
                  },
                  {
                    label: "CREATED DATE",
                    field: "added_date",
                    sort: "asc",
                    width: 5,
                  },
                  {
                    label: localStorage.getItem("verifiertype") === "2"
                      ? "AGE"
                      : "DISTRIBUTOR",
                    field: "distributor",
                    sort: "disabled",
                    width: 5,
                  },

                  {
                    label: localStorage.getItem("verifiertype") === "2"
                      ? "SYMPTOMS" : "DOCTOR NAME",
                    field: "doctor_name",
                    sort: "asc",
                    width: 5,
                  },
                  {
                    label: "MONITORING",
                    field: "monitoring_duration",
                    sort: "disabled",
                    width: 1,
                  },
                  {
                    // Estimated time for the assigned verifier to finish
                    // remaining pending files. Computed server-side from
                    // pending count × verifier's avg seconds-per-file.
                    label: "ETA",
                    field: "eta",
                    sort: "asc",
                    width: 1,
                  },
                ],
                rows: [],
              };

              sortedPatients.forEach((patient, i) => {
                // Read priority from patient — the single source of truth.
                const Priority = getPatientPriority(patient);

                // Variable to store the final time value
                let finalTime;

                // Ensure the date fields are not undefined or null before splitting
                if (patient.ConfirmupdatedDate) {
                  // Split the 'ConfirmupdatedDate' by 'T' to get the date and time parts
                  let confirmButtonTime = patient.ConfirmupdatedDate.split("T");

                  // Get the date part before 'T'
                  let confirmDate = confirmButtonTime[0]; // '2024-11-29'

                  // Get the time part after 'T'
                  let confirmTime = confirmButtonTime[1]
                    ? confirmButtonTime[1].split("Z")[0] // Remove 'Z' if it exists
                    : ""; // If no time part, default to an empty string

                  // Handle removing milliseconds (if any) from confirmTime
                  if (confirmTime) {
                    let time = confirmTime.split(".")[0]; // Get time without milliseconds
                    const confirmbtnTime = confirmDate + " " + time; // Add a space between date and time
                    // console.log("Confirm button time:", confirmbtnTime);

                    // Assign confirmbtnTime to finalTime if available
                    finalTime = confirmbtnTime;
                  } else {
                    // console.log("Confirm Time is empty or invalid");
                  }
                } else {
                  // console.log("ConfirmupdatedDate is undefined or null");
                }

                // Check and split the 'updatedDate' if it's available
                if (patient.updatedDate) {
                  // Split the 'updatedDate' by space to separate date and time
                  let updatedDateTime = patient.updatedDate.split(" ");

                  // Get the date part before the space
                  let updatedDate = updatedDateTime[0]; // '2024-11-29'

                  // Get the time part after the space
                  let updatedTime = updatedDateTime[1]; // '10:28:34'

                  // console.log("Updated Date:", updatedDate, updatedTime);

                  // Combine updatedDate and updatedTime with a space between them
                  const uploadedTime = updatedDate + " " + updatedTime;

                  // Assign uploadedTime to finalTime if confirmbtnTime was not set
                  if (!finalTime) {
                    finalTime = uploadedTime;
                  }
                } else {
                  // console.log("UpdatedDate is undefined or null");
                }

                // Log the final time
                // console.log("Final Time:", finalTime);

                // Get the current time
                const now = new Date();

                // Convert finalTime to Date object
                const finalDate = new Date(finalTime);
                const finalDateMs = finalDate.getTime();
                const isFinalDateValid = Number.isFinite(finalDateMs);

                // Calculate the time difference in milliseconds
                const timeDifference = isFinalDateValid ? now - finalDate : 0; // in milliseconds

                // Convert time difference to hours
                const hoursDifference = Math.max(0, timeDifference / (1000 * 60 * 60)); // milliseconds to hours

                // Set the time limit based on priority. 1=High → 1h,
                // 2=Mod → 2h, 3=Simple → 3h, 4=Normal → 4h, 5=Low → 5h.
                let timeLimit;
                switch (Priority) {
                  case 1: timeLimit = 1; break;
                  case 2: timeLimit = 2; break;
                  case 3: timeLimit = 3; break;
                  case 4: timeLimit = 4; break;
                  case 5: timeLimit = 5; break;
                  default: timeLimit = 4;
                }

                // Calculate the percentage of time used

                let exp_device =
                  patient.exp_device_use_days === 24
                    ? 1
                    : patient.exp_device_use_days === 48
                      ? 2
                      : patient.exp_device_use_days === 72
                        ? 3
                        : patient.exp_device_use_days;

                let timePercentage =
                  (hoursDifference / (timeLimit * exp_device)) * 100; // Calculate the percentage of time used
                // *
                // patient.exp_device_use_days
                if (!Number.isFinite(timePercentage) || timePercentage < 0) {
                  timePercentage = 0;
                }
                if (timePercentage > 100) {
                  timePercentage = 100; // Limit to 100% if the time exceeds the limit
                }
                // Calculate the completion rate (percentage per hour)
                // Calculate the completion rate (percentage per hour)
                const completionRate =
                  hoursDifference > 0 ? timePercentage / hoursDifference : 0; // percentage per hour

                // Predict the total time to complete 100% (in hours)
                const totalCompletionTime =
                  completionRate > 0 ? 100 / completionRate : timeLimit * exp_device; // in hours

                // Calculate the remaining time to complete (in hours)
                const remainingTimeInHours = Math.max(
                  0,
                  totalCompletionTime - hoursDifference
                );

                // Convert the remaining time to minutes
                const remainingTimeInMinutes = remainingTimeInHours * 60;
                const totalSeconds = remainingTimeInMinutes * 60;
                const totalAllowedMs = timeLimit * exp_device * 60 * 60 * 1000;
                const countdownEndTime = isFinalDateValid
                  ? finalDateMs + totalAllowedMs
                  : null;
                // Convert minutes into hours and minutes
                const hours = Math.floor(remainingTimeInMinutes / 60); // Extract whole hours
                const minutes = Math.round(remainingTimeInMinutes % 60); // Get the remaining minutes
                const seconds = Math.floor(totalSeconds % 60);
                // console.log(`hr:${hours} min:${minutes} sec:${seconds}`);
                // Log the predicted remaining time
                // console.log(
                //   `Predicted Remaining Time: ${hours} hours and ${minutes} minutes`
                // );

                // console.log("name", patient.name);
                // console.log("percetage", timePercentage);
                // console.log("timediff", timeDifference);
                // console.log("time limit", timeLimit);

                // Log the result
                // console.log(`Time used: ${hoursDifference.toFixed(2)} hours`);
                // console.log(`Time limit for Priority ${Priority}: ${timeLimit} hours`);
                // console.log(`Percentage of time used: ${timePercentage.toFixed(2)}%`);
                const percentage = timePercentage.toFixed(2);
                const devicemac =
                  patient && patient.deviceInfo && patient.deviceInfo.mac_id;
                // console.log("patient", devicemac);
                // Same source as VerifierHome's DistributorName column:
                // customerName stored on the patient document. Falls back
                // to the device record's customer_details for old patients
                // that predate the customerName field.
                const Distributor_name =
                  (patient && patient.customerName) ||
                  (patient &&
                    patient.deviceInfo &&
                    patient.deviceInfo.customer_details);
                // Patient-driven priority drives the tag/badge. Kept the
                // variable name `devicepriority` to avoid touching the many
                // template references that already use it.
                const devicepriority = getPatientPriority(patient);

                const totalEcgValues = patient.ecgValues.length;
                const verifiedEcgValues = patient.ecgValues.filter(
                  (ecgValue) => ecgValue.verifyStatus === 1
                );
                // 0/0 means nothing has been uploaded for this patient yet —
                // there's no file for the verifier to work on, so skip the
                // row entirely instead of showing an empty "0 /0" badge.
                if (totalEcgValues === 0 && verifiedEcgValues.length === 0) {
                  return;
                }
                const verifiedPercentage = `${verifiedEcgValues.length} /${totalEcgValues} `;

                const createdData = patient.created_at.split("T");

                let url = " ";
                let anl_btn_txt = "teststart";
                let anl_btn_class = "btn-danger";
                let gen_btn_txt = "Not Generated";
                let gen_btn_class = "btn-danger";
                let report_link = "#";
                let report_link_target = "";

                if (patient.LastDatasetId !== undefined) {
                  url =
                    patient.backup_status === 0 ||
                      patient.backup_status === undefined
                      ? `/verifier-unanalysed/${patient._id}/${patient.LastDatasetId}`
                      : " ";
                }

                if (patient.report_status >= 1) {
                  anl_btn_txt = "Analyzing...";
                  anl_btn_class = "btn-success";
                }

                if (patient.report_status >= 2) {
                  anl_btn_txt = "test";
                  anl_btn_class = "btn-success";
                  url =
                    patient.backup_status === 0 ||
                      patient.backup_status === undefined
                      ? `/verifier-chart/${patient._id}/${patient.LastDatasetId}`
                      : " ";
                }

                if (patient.report_status >= 4) {
                  gen_btn_txt = "In Preparation";
                  gen_btn_class = "btn-yellow";
                }
                if (patient.report_status >= 5) {
                  gen_btn_txt = "Not Generated";
                  gen_btn_class = "btn-danger";
                  report_link_target = "_blank";
                  report_link = "";
                }

                anl_btn_txt =
                  patient.backup_status === 0 ||
                    patient.backup_status === undefined
                    ? "TEST3"
                    : patient.backup_status === 1
                      ? "Retrieve"
                      : "Retrieving";

                const updateddate = patient.ConfirmupdatedDate
                  ? patient.ConfirmupdatedDate.replace("T", " ").split(
                    ".000Z"
                  )[0]
                  : patient.updatedDate;

                // Set report button text and class based on ReportGeneration
                if (patient.ReportGeneration) {
                  gen_btn_txt = "Generated";
                  gen_btn_class = "btn-primary";
                }

                // ETA — pull from the etaMap built earlier. Format:
                //   < 60 min  → "Xm"
                //   < 24 h    → "Xh Ym"
                //   ≥ 24 h    → "Xd Yh"
                //   no data   → "—"
                const etaInfo =
                  this.state.etaMap && this.state.etaMap[String(patient._id)];
                const fmtEta = (minutes) => {
                  if (!Number.isFinite(minutes) || minutes <= 0) return "—";
                  if (minutes < 60) return `${Math.round(minutes)}m`;
                  if (minutes < 24 * 60) {
                    const h = Math.floor(minutes / 60);
                    const m = Math.round(minutes % 60);
                    return m > 0 ? `${h}h ${m}m` : `${h}h`;
                  }
                  const days = Math.floor(minutes / (24 * 60));
                  const h = Math.round((minutes % (24 * 60)) / 60);
                  return h > 0 ? `${days}d ${h}h` : `${days}d`;
                };
                const etaCell = etaInfo && etaInfo.etaMinutes > 0 ? (
                  <span
                    title={buildEtaTooltip(etaInfo)}
                    style={{ fontVariantNumeric: "tabular-nums" }}
                  >
                    {fmtEta(etaInfo.etaMinutes)}
                  </span>
                ) : (
                  <span style={{ color: "#666" }}>—</span>
                );

                const myBlock =
                  this.state.blockMap && this.state.blockMap[String(patient._id)];

                data.rows.push({
                  report_status: patient.report_status,
                  backup_status: patient.backup_status,
                  LastDatasetId: patient.LastDatasetId,
                  // Only show the real assigned block/part label (e.g. "day 1",
                  // "first hlf") from myBlockAssignments. No generic "Full"
                  // fallback — that masked which part is actually assigned in
                  // the Queue view, and showed a misleading badge on the main
                  // Patient List for patients that just happen to be in this
                  // verifier's `patients` array without a specific block.
                  block: myBlock || "",
                  progress_raw: parseInt(patient.progress) || 0,
                  ReportGeneration: patient.ReportGeneration || null,
                  slno: i + 1,
                  patientId: patient.device_id,
                  _id: patient._id,
                  confirmation: patient.Confirmation,
                  name: capitalizeFirstLetter(patient.name),
                  added_date: createdData[0],
                  distributor: Distributor_name,
                  doctor_name: patient.doctorName,
                  eta: etaCell,
                  etaMinutesRaw: etaInfo ? etaInfo.etaMinutes || 0 : 0,
                  // Upload time as a number, for oldest-first ordering
                  // inside each priority band.
                  uploadMs: uploadTimeMs(patient),
                  // Only an explicitly assigned High/Moderate/Simple counts.
                  // Everything else is "unprioritised" (bucket 4) — no
                  // fabricated "Normal" default.
                  priorityNum: assignedPriorityRank(patient) <= 3 ? assignedPriorityRank(patient) : 4,
                  priority: (() => {
                    const rank = assignedPriorityRank(patient); // 1/2/3 or 99
                    const tagMap = {
                      1: { label: "High",     cls: "priority-tag-high"     },
                      2: { label: "Moderate", cls: "priority-tag-moderate" },
                      3: { label: "Simple",   cls: "priority-tag-simple"   },
                    };
                    const tag = tagMap[rank]; // undefined → not prioritised
                    return (
                      <button
                        type="button"
                        className="btn btn-link"
                        style={{ background: "none", border: "none", padding: "4px 8px", cursor: "pointer", textDecoration: "none" }}
                        onClick={(e) =>
                          this.openPriorityModal(e, {
                            userid: patient._id,
                            macid: devicemac,
                            priority: tag ? String(rank) : "",
                            confirmDate: patient.ConfirmupdatedDate || patient.updatedDate,
                          })
                        }
                      >
                        {tag ? (
                          <span className={`priority-tag ${tag.cls}`}>{tag.label}</span>
                        ) : (
                          <span style={{ color: "#5b7688", fontSize: "11px", fontWeight: 600, opacity: 0.85 }}>＋ Set priority</span>
                        )}
                      </button>
                    );
                  })(),
                  pacemaker:
                    patient.hyper_lipidemia === true
                      ? "Yes"
                      : patient.hyper_lipidemia === false
                        ? "No"
                        : "N/A",
                  // Ensure `doctor_name` is populated
                  action: (() => {
                    // safe verifier lookup
                    const verifierList = Array.isArray(this.state.allverifiers) ? this.state.allverifiers : [];
                    const assignedVerifier = verifierList.find((v) => v.patients && v.patients.includes(patient._id));

                    // safe confirm date/time
                    let confirmDate = "";
                    let confirmTime = "";
                    if (patient.ConfirmupdatedDate) {
                      const parts = patient.ConfirmupdatedDate.split("T");
                      confirmDate = parts[0] || "";
                      confirmTime = parts[1] ? parts[1].split(".")[0].replace("Z", "") : "";
                    }

                    return (
                      <div style={{ display: "flex", flexDirection: "column", gap: "5px", minWidth: "150px" }}>

                        {/* Buttons row */}
                        <div style={{ display: "flex", flexWrap: "wrap", gap: "4px", alignItems: "center" }}>
                          {this.state.verifiertype === "8" && (
                            <button
                              type="button"
                              id={patient._id}
                              dataid2={devicemac}
                              dataid3={devicepriority}
                              title="Edit Patient"
                              onClick={this.getInfo}
                              data-toggle="modal"
                              data-target="#editInfoModal"
                              style={{ background: "none", border: "none", padding: "3px 5px", cursor: "pointer", color: "#f0a500", fontSize: "16px", lineHeight: 1 }}
                            >✏️</button>
                          )}
                          <button
                            type="button"
                            id={patient._id}
                            style={{ padding: "3px 8px", fontSize: "13px", height: "28px", background: "#2c5f8a", border: "1px solid #3a82c4", color: "#fff", borderRadius: "4px" }}
                            onClick={this.getInfo}
                            data-toggle="modal"
                            data-target="#commentinfomodal"
                            title="Comments"
                          >💬</button>
                          {this.state.verifiertype === "8" && !patient.ConfirmupdatedDate && (
                            <button
                              type="button"
                              id={patient._id}
                              style={{ padding: "3px 8px", fontSize: "16px" }}
                              onClick={this.getConfirmTime}
                              className="btn btn-sm"
                              title="Confirm"
                            >✅</button>
                          )}
                        </div>

                        {/* File count */}
                        <div
                          style={{ display: "flex", alignItems: "center", gap: "4px", cursor: "pointer" }}
                          id={patient._id}
                          onClick={this.getverifiedprogress}
                          data-toggle="modal"
                          data-target="#progressinfomodal"
                        >
                          <span style={{ fontSize: "10px", color: "#aaa" }}>Files:</span>
                          <span style={{ fontSize: "12px", fontWeight: 700, color: "#5ac8fa", background: "rgba(90,200,250,0.12)", border: "1px solid rgba(90,200,250,0.3)", borderRadius: "8px", padding: "1px 7px" }}>
                            {verifiedPercentage}
                          </span>
                        </div>

                        {/* Verifier name */}
                        <div style={{ display: "flex", alignItems: "center", gap: "4px" }}>
                          <span style={{ fontSize: "11px", color: "#888" }}>👤</span>
                          <span style={{ fontSize: "11px", color: assignedVerifier ? "#a8d8a8" : "#666", fontStyle: assignedVerifier ? "normal" : "italic" }}>
                            {assignedVerifier ? assignedVerifier.name : "Unassigned"}
                          </span>
                        </div>

                        {/* Confirmation date + time + who */}
                        {confirmDate ? (
                          <div style={{ display: "flex", flexDirection: "column", gap: "1px" }}>
                            <span style={{ fontSize: "10px", color: "#888" }}>✔ Confirmed</span>
                            <span style={{ fontSize: "11px", fontWeight: 600, color: "#30d158" }}>{confirmDate}</span>
                            {confirmTime && <span style={{ fontSize: "10px", color: "#30d158", opacity: 0.8 }}>{confirmTime}</span>}
                            {/* Who confirmed — staff name or 📱 Customer
                                (WhatsApp). Reads ConfirmedBy and falls back
                                to ConfirmationSource for legacy rows that
                                only have the source tag. */}
                            {(patient.ConfirmedBy || patient.ConfirmationSource) && (
                              <span style={{ fontSize: "10px", color: "#888", marginTop: "2px", display: "inline-flex", alignItems: "center", gap: "3px" }}>
                                {patient.ConfirmationSource === "whatsapp"
                                  ? "📱 "
                                  : "👤 "}
                                {patient.ConfirmedBy ||
                                  (patient.ConfirmationSource === "whatsapp"
                                    ? "Customer (WhatsApp)"
                                    : "Staff")}
                              </span>
                            )}
                          </div>
                        ) : null}

                      </div>
                    );
                  })(),

                  report: (
                    <div
                      style={
                        this.state.verifiertype !== "8"
                          ? { display: "none" }
                          : { minWidth: "140px", maxWidth: "180px" }
                      }
                    >
                      {/* TAT display — compact card style */}
                      <div style={{ margin: "4px 0 8px" }}>
                        {/* Countdown pill */}
                        {countdownEndTime ? (
                          <Countdown
                            date={countdownEndTime}
                            renderer={({ hours, minutes, seconds, completed }) => {
                              const reportDone = !!patient.ReportGeneration;
                              const isAlarm = (completed || timePercentage >= 80) && !reportDone;
                              const barColor = isAlarm
                                ? "#ff3b30"
                                : timePercentage >= 50 && !reportDone
                                  ? "#ff9f0a"
                                  : "#30d158";
                              const pillBg = isAlarm
                                ? "#3a0a08"
                                : timePercentage >= 50 && !reportDone
                                  ? "#3a2208"
                                  : "#0a2a14";
                              return (
                                <div>
                                  {/* Timer badge */}
                                  <div style={{
                                    display: "inline-flex",
                                    alignItems: "center",
                                    gap: "5px",
                                    background: pillBg,
                                    border: `1px solid ${barColor}`,
                                    borderRadius: "20px",
                                    padding: "3px 10px",
                                    marginBottom: "6px",
                                  }}>
                                    <span style={{ fontSize: "11px", color: barColor }}>{reportDone && completed ? "✅" : "⏱"}</span>
                                    <span style={{
                                      fontSize: "12px",
                                      fontWeight: 700,
                                      color: barColor,
                                      letterSpacing: "0.4px",
                                      fontVariantNumeric: "tabular-nums",
                                    }}>
                                      {completed
                                        ? (reportDone ? "Delivered" : "TIME OVER")
                                        : `${String(hours).padStart(2,"0")}h ${String(minutes).padStart(2,"0")}m ${String(seconds).padStart(2,"0")}s`}
                                    </span>
                                  </div>
                                  {/* Slim progress bar */}
                                  <div style={{
                                    height: "6px",
                                    width: "100%",
                                    backgroundColor: "rgba(255,255,255,0.08)",
                                    borderRadius: "4px",
                                    overflow: "hidden",
                                  }}>
                                    <div style={{
                                      height: "100%",
                                      width: `${timePercentage}%`,
                                      backgroundColor: barColor,
                                      borderRadius: "4px",
                                      transition: "width 0.5s ease",
                                    }} />
                                  </div>
                                  <div style={{
                                    fontSize: "10px",
                                    color: "#666",
                                    marginTop: "3px",
                                    textAlign: "right",
                                  }}>{timePercentage.toFixed(0)}%</div>
                                </div>
                              );
                            }}
                          />
                        ) : (
                          <span style={{
                            fontSize: "11px",
                            color: "#555",
                            background: "rgba(255,255,255,0.06)",
                            borderRadius: "12px",
                            padding: "3px 10px",
                            border: "1px solid #333",
                          }}>No TAT</span>
                        )}
                        {/* invisible spacer to maintain old layout compat */}
                        <div
                          style={{
                            height: "0px",
                            width: "0px",
                            overflow: "hidden",
                            position: "absolute",
                          }}
                        >
                          {/* Centered percentage text — kept for compat */}
                          <div
                            style={{
                              position: "absolute",
                              top: 0,
                              left: 0,
                              height: "100%",
                              width: "100%",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              fontWeight: "bold",
                              color: "#120d0d",
                            }}
                          >
                            {timePercentage.toFixed(2)}%
                          </div>
                        </div>
                      </div>

                      <React.Fragment>
                        {gen_btn_txt !== "Not Generated" && (
                        <a
                          id={patient._id}
                          style={
                            gen_btn_class === "btn-yellow"
                              ? { backgroundColor: "#2ecd99" }
                              : {}
                          }
                          onClick={() =>
                            this.generateReport(
                              patient.report_status,
                              patient._id
                            )
                          }
                        >
                          <button
                            type="button"
                            className={`btn btn-sm ${gen_btn_class}`}
                            style={{
                              padding: "3px 10px",
                              fontSize: "11px",
                              ...(gen_btn_class === "btn-yellow" ? { backgroundColor: "#2ecd99" } : {}),
                            }}
                          >
                            {gen_btn_txt}
                          </button>
                        </a>
                        )}
                        <input
                          type="hidden"
                          className="patientLink"
                          value={url}
                        />
                      </React.Fragment>
                    </div>
                  ),

                  monitoring_duration: (() => {
                    const vList = Array.isArray(this.state.allverifiers) ? this.state.allverifiers : [];
                    const av = vList.find((v) => v.patients && v.patients.includes(patient._id));
                    const d = Number(patient.exp_device_use_days);
                    const days = d >= 24 ? Math.round(d / 24) : d;

                    // ETA — pulled from etaMap built in fetchData. Shown above
                    // the analysis status badge so it sits next to the
                    // verification progress for at-a-glance comparison.
                    // When the verifier's recent pace is ≥ 2× their baseline
                    // (isSlowdown), the badge turns red and shows ⚠ instead
                    // of ⏳ so reviewers spot the slowdown quickly.
                    const etaInfo =
                      (this.state.etaMap && this.state.etaMap[String(patient._id)]) || null;
                    const fmtEtaInline = (minutes) => {
                      if (!Number.isFinite(minutes) || minutes <= 0) return null;
                      if (minutes < 60) return `${Math.round(minutes)}m`;
                      if (minutes < 24 * 60) {
                        const h = Math.floor(minutes / 60);
                        const m = Math.round(minutes % 60);
                        return m > 0 ? `${h}h ${m}m` : `${h}h`;
                      }
                      const dd = Math.floor(minutes / (24 * 60));
                      const h = Math.round((minutes % (24 * 60)) / 60);
                      return h > 0 ? `${dd}d ${h}h` : `${dd}d`;
                    };
                    const etaText = etaInfo ? fmtEtaInline(etaInfo.etaMinutes) : null;
                    const etaSlow = !!(etaInfo && etaInfo.isSlowdown);
                    // Critical slowdown: recent pace ≥ 2.5× baseline → blink.
                    // Inclusive boundary because slowdownRatio is rounded to
                    // one decimal on the backend — a true 2.46 rounds to 2.5
                    // and the user expects that to fire the blink too.
                    const etaCritical = !!(
                      etaInfo &&
                      etaInfo.slowdownRatio &&
                      etaInfo.slowdownRatio >= 2.5
                    );
                    const etaColor = etaSlow ? "#ef4444" : "#5ac8fa";
                    const etaBg = etaSlow
                      ? "rgba(239,68,68,0.12)"
                      : "rgba(90,200,250,0.10)";
                    const etaBorder = etaSlow
                      ? "rgba(239,68,68,0.55)"
                      : "rgba(90,200,250,0.35)";
                    const etaIcon = etaCritical ? "🚨" : etaSlow ? "⚠" : "⏳";
                    const etaTooltip = etaInfo
                      ? buildEtaTooltip(etaInfo) +
                        (etaCritical
                          ? ` · CRITICAL: ${etaInfo.slowdownRatio}× slower (recent ${etaInfo.recentAvgSec}s vs baseline ${etaInfo.baselineAvgSec}s)`
                          : etaSlow
                            ? ` · slowed ${etaInfo.slowdownRatio}× (recent ${etaInfo.recentAvgSec}s vs baseline ${etaInfo.baselineAvgSec}s)`
                            : etaInfo.speedSource === "recent"
                              ? " · live pace"
                              : "")
                      : "";

                    const dateParts  = updateddate ? updateddate.split(" ") : [];
                    const dateOnly   = dateParts[0] || "—";
                    const timeOnly   = dateParts[1] ? dateParts[1].substring(0, 5) : ""; // HH:mm
                    let confirmDate = "", confirmTime = "";
                    if (patient.ConfirmupdatedDate) {
                      const p = patient.ConfirmupdatedDate.split("T");
                      confirmDate = p[0] || "";
                      confirmTime = p[1] ? p[1].split(".")[0].replace("Z","") : "";
                    }
                    // Analysis status info
                    const rs = patient.report_status;
                    // ReportGeneration is a one-time timestamp from whenever a
                    // report was last generated for this patient — it can be
                    // stale from an earlier monitoring cycle while THIS round
                    // of files still has unverified work (e.g. 0/46 done).
                    // Only trust it as "done" when there's nothing left
                    // unverified right now.
                    const unverifiedCount = totalEcgValues - verifiedEcgValues.length;
                    const reportDone =
                      !!patient.ReportGeneration &&
                      (totalEcgValues === 0 || unverifiedCount <= 0);

                    // Use actual progress field from patients collection
                    const rawProgress = parseInt(patient.progress) || 0;
                    const analysisPct = (reportDone || rs === 5) ? 100
                      : rs === 4 ? 90
                      : rs === 3 ? 75
                      : (rs === 2 || rs === 6 || rs === 1)
                        ? Math.min(99, Math.max(1, rawProgress))
                      : 0;

                    const _snap = this.state.progressSnapshot[patient._id];
                    // "still analyzing" = rs 1, or rs 2/6 but progress hasn't reached 100 yet
                    const _isAnalyzing = rs === 1 ||
                      ((rs === 2 || rs === 6) && rawProgress > 0 && rawProgress < 100);
                    const _isStuck = _isAnalyzing && _snap &&
                      (Date.now() - _snap.lastUpdated > 5 * 60 * 1000);

                    const statusInfo = reportDone
                      ? { label: "Report Completed",       color: "#30d158", bg: "rgba(48,209,88,0.13)",    bar: "#30d158",  pct: 100 }
                      : rs === 5
                      ? { label: "Report Completed",       color: "#30d158", bg: "rgba(48,209,88,0.13)",    bar: "#30d158",  pct: 100 }
                      : rs === 4
                      ? { label: "In Preparation",         color: "#2ecd99", bg: "rgba(46,205,153,0.13)",   bar: "#2ecd99",  pct: 90  }
                      : rs === 3
                      ? { label: "Verif. Completed",       color: "#a78bfa", bg: "rgba(167,139,250,0.13)",  bar: "#a78bfa",  pct: 75  }
                      : _isStuck
                      ? { label: "Possible Stuck",         color: "#ff453a", bg: "rgba(255,69,58,0.18)",    bar: "#ff453a",  pct: analysisPct }
                      : _isAnalyzing
                      ? { label: "Analysis Started",       color: "#ff9f0a", bg: "rgba(255,159,10,0.13)",   bar: "#ff9f0a",  pct: analysisPct }
                      : rs === 2 || rs === 6
                      ? { label: "Analyze Completed",      color: "#5ac8fa", bg: "rgba(90,200,250,0.13)",   bar: "#5ac8fa",  pct: 100  }
                      : rs === 1
                      ? { label: "Analyzing...",           color: "#ff9f0a", bg: "rgba(255,159,10,0.13)",   bar: "#ff9f0a",  pct: analysisPct }
                      : { label: "Not Analyzed",           color: "#ff3b30", bg: "rgba(255,59,48,0.13)",    bar: "#ff3b30",  pct: 0   };

                    const cnt = patient.comments ? patient.comments.split("\n").filter(l => l.trim()).length : 0;

                    return (
                      <div style={{ display: "flex", gap: "8px", alignItems: "stretch", fontSize: "12px" }}>

                        {/* ── LEFT: action buttons + TAT + report btn ── */}
                        <div style={{ flex: "0 0 auto", minWidth: 0 }}>

                          {/* Line 1: action buttons + file count */}
                          <div style={{ display: "flex", alignItems: "center", gap: "5px", marginBottom: "5px", flexWrap: "wrap" }}>
                            {(this.state.verifiertype === "8" || this.state.verifiertype === "1" || this.state.verifiertype === "10") && (
                              <button type="button" id={patient._id} dataid2={devicemac} dataid3={devicepriority}
                                title="Edit Patient" onClick={this.getInfo}
                                data-toggle="modal" data-target="#editInfoModal"
                                style={{ background: "none", border: "none", padding: "1px 4px", cursor: "pointer", color: "#f0a500", fontSize: "15px", lineHeight: 1 }}>✏️</button>
                            )}
                            <button type="button" id={patient._id}
                              style={{ padding: "1px 7px", fontSize: "11px", height: "22px", background: "#1d4a6e", border: "1px solid #2e6fa3", color: "#fff", borderRadius: "4px", display: "inline-flex", alignItems: "center", gap: 3 }}
                              onClick={this.getInfo} data-toggle="modal" data-target="#commentinfomodal" title="Comments">
                              💬 <span style={{ fontSize: "10px", background: cnt > 0 ? "#e8f4fd" : "rgba(255,255,255,0.15)", color: cnt > 0 ? "#1a6fa3" : "#aad4f5", borderRadius: 8, padding: "0 4px", fontWeight: 700 }}>{cnt}</span>
                            </button>
                            {this.state.verifiertype === "8" && !patient.ConfirmupdatedDate && (
                              <button type="button" id={patient._id} onClick={this.getConfirmTime}
                                className="btn btn-sm" title="Confirm"
                                style={{ padding: "1px 6px", fontSize: "12px", height: "22px", lineHeight: 1 }}>✅</button>
                            )}
                            <span id={patient._id} onClick={this.getverifiedprogress}
                              data-toggle="modal" data-target="#progressinfomodal"
                              style={{ cursor: "pointer", fontSize: "13px", fontWeight: 700, color: "#5ac8fa", background: "rgba(90,200,250,0.10)", border: "1px solid rgba(90,200,250,0.25)", borderRadius: "8px", padding: "2px 8px" }}>
                              📁 {verifiedPercentage}
                            </span>
                          </div>

                          {/* Pacemaker status badge — only shown when pacemaker is true */}
                          {patient.hyper_lipidemia === true && (
                            <div style={{ marginTop: 4 }}>
                              <span style={{
                                fontSize: "11px", fontWeight: 600,
                                background: "rgba(255,69,58,0.15)",
                                color: "#ff453a",
                                border: "1px solid rgba(255,69,58,0.35)",
                                borderRadius: "8px", padding: "1px 7px", whiteSpace: "nowrap",
                              }}>
                                🫀 Pacemaker
                              </span>
                            </div>
                          )}

                          {/* Line 2: Images + TAT + report — one line, under the
                              files count. Images shows for everyone; the TAT
                              time / report button stay admin-only (type 8). */}
                          <div style={{ display: "flex", alignItems: "center", gap: "5px", flexWrap: "wrap", marginTop: 4 }}>
                            <button
                              type="button"
                              onClick={(e) => { e.stopPropagation(); this.setState({ stripsUserid: patient.device_id }); }}
                              title="View uploaded ECG images"
                              style={{ display: "inline-flex", alignItems: "center", justifyContent: "center", fontSize: "13px", color: "#5ac8fa", background: "transparent", border: "1px solid rgba(90,200,250,0.4)", borderRadius: "6px", padding: "1px 7px", cursor: "pointer" }}
                            >
                              🖼
                            </button>
                            {this.state.verifiertype === "8" && (
                              <React.Fragment>
                              {countdownEndTime ? (
                                <Countdown date={countdownEndTime} renderer={({ hours, minutes, seconds, completed }) => {
                                  const rd = !!patient.ReportGeneration;
                                  const isAlarm = (completed || timePercentage >= 80) && !rd;
                                  const c = isAlarm ? "#ff3b30" : timePercentage >= 50 && !rd ? "#ff9f0a" : "#30d158";
                                  const bg = isAlarm ? "#3a0a08" : timePercentage >= 50 && !rd ? "#3a2208" : "#0a2a14";
                                  return (
                                    <span style={{ display: "inline-flex", alignItems: "center", gap: "3px", background: bg, border: `1px solid ${c}`, borderRadius: "20px", padding: "1px 7px" }}>
                                      <span style={{ fontSize: "10px", color: c }}>{rd && completed ? "✅" : "⏱"}</span>
                                      <span style={{ fontSize: "10px", fontWeight: 700, color: c, fontVariantNumeric: "tabular-nums" }}>
                                        {completed ? (rd ? "Delivered" : "TIME OVER") : `${String(hours).padStart(2,"0")}h ${String(minutes).padStart(2,"0")}m`}
                                      </span>
                                    </span>
                                  );
                                }} />
                              ) : (
                                <span style={{ fontSize: "10px", color: "#444", background: "rgba(255,255,255,0.05)", borderRadius: "12px", padding: "1px 7px", border: "1px solid #2a3a40" }}>No TAT</span>
                              )}
                              {gen_btn_txt !== "Not Generated" && (
                                <a id={patient._id} onClick={() => this.generateReport(patient.report_status, patient._id)}>
                                  <button type="button" className={`btn btn-sm ${gen_btn_class}`}
                                    style={{ padding: "0px 5px", fontSize: "9px", height: "17px", lineHeight: 1, letterSpacing: "0.2px", ...(gen_btn_class === "btn-yellow" ? { backgroundColor: "#2ecd99" } : {}) }}>
                                    {gen_btn_txt}
                                  </button>
                                </a>
                              )}
                              <input type="hidden" className="patientLink" value={url} />
                              </React.Fragment>
                            )}
                          </div>
                        </div>

                        {/* ── CENTRE: duration + upload date & time ──
                            Upload date+time on a single line at 12px,
                            sitting 1pt above the confirm line (11px). */}
                        <div style={{ flex: 1, display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", gap: "4px", padding: "0 6px" }}>
                          <span style={{ background: "rgba(90,200,250,0.12)", color: "#5ac8fa", border: "1px solid rgba(90,200,250,0.25)", borderRadius: "8px", padding: "2px 10px", fontSize: "14px", fontWeight: 700 }}>
                            {days} Day
                          </span>
                          <span style={{ fontSize: "12px", fontWeight: 600, color: "#cde", opacity: 0.9, whiteSpace: "nowrap", fontVariantNumeric: "tabular-nums" }}>
                            {dateOnly}
                            {timeOnly ? ` ${timeOnly}` : ""}
                          </span>
                          {/* ✔ Confirm time + 👤 confirmer on a single row.
                              Lives under the upload date and just above the
                              files-count column to its left, so staff can
                              read confirmation status as one line:
                                  "✔ 2026-05-04 20:39   👤 Admin"
                          */}
                          {(confirmDate || patient.ConfirmedBy || patient.ConfirmationSource) && (
                            <div
                              style={{
                                display: "inline-flex",
                                alignItems: "center",
                                gap: "8px",
                                flexWrap: "wrap",
                                justifyContent: "center",
                                whiteSpace: "nowrap",
                              }}
                            >
                              {confirmDate && (
                                <span style={{ fontSize: "11px", color: "#30d158" }}>
                                  ✔ {confirmDate}
                                  {confirmTime ? ` ${confirmTime.substring(0, 5)}` : ""}
                                </span>
                              )}
                              {(patient.ConfirmedBy || patient.ConfirmationSource) && (
                                <span
                                  style={{
                                    fontSize: "10px",
                                    color: "#888",
                                    display: "inline-flex",
                                    alignItems: "center",
                                    gap: "3px",
                                  }}
                                  title={
                                    patient.ConfirmupdatedDate
                                      ? `Last set on ${patient.ConfirmupdatedDate
                                          .replace("T", " ")
                                          .split(".")[0]}`
                                      : ""
                                  }
                                >
                                  {patient.ConfirmationSource === "whatsapp"
                                    ? "📱 "
                                    : "👤 "}
                                  {patient.ConfirmedBy ||
                                    (patient.ConfirmationSource === "whatsapp"
                                      ? "Customer (WhatsApp)"
                                      : "Staff")}
                                </span>
                              )}
                            </div>
                          )}
                        </div>

                        {/* ── RIGHT: ETA + analysis status + progress bar ── */}
                        <div style={{ width: "115px", flexShrink: 0, display: "flex", flexDirection: "column", alignItems: "flex-end", justifyContent: "center", gap: "5px" }}>
                          {/* ETA badge — shown only when there's pending work.
                              Cyan = normal. Red (static) = recent pace ≥ 2×
                              baseline. Red (blinking, .eta-critical) = recent
                              pace > 2.5× baseline. */}
                          {etaText && (
                            <span
                              title={etaTooltip}
                              className={etaCritical ? "eta-critical" : ""}
                              style={{
                                fontSize: "10px", fontWeight: 700,
                                color: etaColor,
                                background: etaBg,
                                border: `1px solid ${etaBorder}`,
                                borderRadius: "8px", padding: "2px 7px",
                                width: "100%", textAlign: "center",
                                fontVariantNumeric: "tabular-nums",
                                whiteSpace: "nowrap",
                                display: "block",
                                transition: "color 0.2s ease, background 0.2s ease, border-color 0.2s ease",
                              }}
                            >
                              {etaIcon} ETA {etaText}
                              {etaSlow ? ` (${etaInfo.slowdownRatio}×)` : ""}
                            </span>
                          )}
                          {/* Status badge — wraps text if needed */}
                          <span style={{
                            fontSize: "9px", fontWeight: 700, color: statusInfo.color,
                            background: statusInfo.bg, border: `1px solid ${statusInfo.color}55`,
                            borderRadius: "8px", padding: "3px 7px", textAlign: "center",
                            wordBreak: "break-word", letterSpacing: "0.2px", width: "100%",
                            display: "block", lineHeight: 1.4
                          }}>
                            {statusInfo.label}
                          </span>
                          {/*
                            Progress % + bar — shown ONLY while the patient
                            is actively being analyzed. Once rs >= 2 (analyzed)
                            with progress = 100 (or rs >= 3 generally), the
                            status badge above already says "Analyze Completed"
                            / "Verif. Completed" / "Report Completed" — the
                            old code still rendered "99%" + a 99%-filled bar
                            here (because analysisPct was clamped to 99),
                            which looked stuck. Hide both once done.
                          */}
                          {_isAnalyzing && (
                            <>
                              {/* Progress % */}
                              <span style={{ fontSize: "10px", fontWeight: 700, color: statusInfo.color, textAlign: "right", width: "100%" }}>
                                {analysisPct}%
                              </span>
                              {/* Progress bar */}
                              <div style={{ height: "6px", width: "100%", background: "rgba(255,255,255,0.08)", borderRadius: "4px", overflow: "hidden" }}>
                                <div style={{
                                  height: "100%", width: `${analysisPct}%`,
                                  background: statusInfo.bar, borderRadius: "4px",
                                  transition: "width 0.5s ease",
                                  boxShadow: analysisPct > 0 ? `0 0 5px ${statusInfo.bar}88` : "none"
                                }} />
                              </div>
                            </>
                          )}
                        </div>

                      </div>
                    );
                  })(),
                  TimePercentage: (
                    <div
                      style={{
                        color: "transparent",
                        display: "flex",
                        position: "absolute",
                      }}
                    >
                      {percentage}
                    </div>
                  ),
                  hourstocompleted: (
                    <div
                      style={{
                        color: "transparent",
                        display: "flex",
                        position: "absolute",
                      }}
                    >
                      {`${hours} hours and ${minutes} minutes`}
                    </div>
                  ),
                  DOB: patient.dob,
                  indication: patient.indication,
                });
              });

              // Update progressSnapshot for patients still analyzing
              const now = Date.now();
              const updatedSnapshot = { ...this.state.progressSnapshot };
              filteredPatients.forEach((p) => {
                const rawProg = parseInt(p.progress) || 0;
                const rs2 = p.report_status;
                const isAnalyzing = rs2 === 1 ||
                  ((rs2 === 2 || rs2 === 6) && rawProg > 0 && rawProg < 100);
                if (isAnalyzing) {
                  const existing = updatedSnapshot[p._id];
                  if (!existing || existing.progress !== rawProg) {
                    updatedSnapshot[p._id] = { progress: rawProg, lastUpdated: now };
                  }
                }
              });

              // Single setState — avoids 3 separate re-renders
              this.setState(
                {
                  data: data,
                  columns: data.columns,
                  rows: data.rows,
                  progressSnapshot: updatedSnapshot,
                },
                () => {
                  this.applyRowStyles();
                  this.checkTatNotifications();
                }
              );

              // this.setState({ data }, () => {
              //   this.applyRowStyles();

              //   // Bind click events for table rows
              //   const table = document.getElementById("table");
              //   table.addEventListener("click", (event) => {
              //     const target = event.target;
              //     if (
              //       target.closest(
              //         "td:nth-child(2), td:nth-child(3), td:nth-child(4)"
              //       )
              //     ) {
              //       const url = target
              //         .closest("tr")
              //         .querySelector(".patientLink").value;
              //       if (url !== " ") {
              //         window.location.href = url;
              //         // console.log("url:", url);
              //       }
              //     }
              //   });
              // });
            }
          );
          });
        })
      )
      .catch((err) => {
        console.error("Error fetching data:", err);
      });
  };
  // Patients whose app reported remote mode in the last 24 h → "REMOTE"
  // badge, so staff can mark them Live before they are analysed as Holter.
  // Failure tolerant: no badge if the call fails.
  loadRemoteMode = () => {
    axios
      .get(apiUrl + "api/users/remoteModePatients")
      .then((res) => {
        const d = res.data || {};
        this.setState({
          remoteUserIds: new Set(d.userIds || []),
          remoteDeviceIds: new Set(d.deviceIds || []),
        });
      })
      .catch(() => {});
  };

  isRemoteMode = (row) => {
    const u = this.state.remoteUserIds;
    const d = this.state.remoteDeviceIds;
    return !!((u && u.has(String(row._id))) || (d && d.has(String(row.patientId))));
  };

  componentDidMount() {
    // Fetch data initially
    this.fetchData();

    // Set an interval to check the condition and fetch data
    this.intervalId = setInterval(() => {
      if (!this.state.isModalCompleteOpen) {
        this.fetchData();
      }
    }, 30000); // 30 seconds

    // Set an interval to check TAT notifications every 1 minute
    this.tatNotificationIntervalId = setInterval(() => {
      if (!this.state.isModalCompleteOpen) {
        this.checkTatNotifications();
      }
    }, 60000); // 1 minute

    // Set an interval to reset notification tracking every 1 minute
    this.tatResetIntervalId = setInterval(() => {
      this.setState({
        tatNotifications: new Set(),
        isShowingNotification: false,
        notificationQueue: [],
      });
    }, 60000); // 1 minute

    // Check if we need to reset notifications (daily reset)
    const now = new Date();
    const lastReset = localStorage.getItem("lastTatNotificationReset");
    const today = now.toDateString();

    if (lastReset !== today) {
      this.resetTatNotifications();
      localStorage.setItem("lastTatNotificationReset", today);
    }

    // Type-10 only: popup when the admin assigns a new patient, so a
    // verifier here (Patient List or the Queue view — same component)
    // notices without having to refresh and compare lists.
    if (localStorage.getItem("verifiertype") === "10") {
      this.checkNewAssignments();
      this.assignmentAlertInterval = setInterval(this.checkNewAssignments, 60000);
    }
  }

  componentWillUnmount() {
    // Clear the intervals when the component unmounts
    clearInterval(this.intervalId);
    clearInterval(this.tatNotificationIntervalId);
    clearInterval(this.tatResetIntervalId);
    clearInterval(this.assignmentAlertInterval);
  }

  checkNewAssignments = () => {
    axios
      .get(`${apiUrl}api/users/myNewAssignments`)
      .then((res) => {
        const alerts = (res.data && res.data.alerts) || [];
        if (alerts.length) {
          this.setState({ newAssignmentAlerts: alerts });
          $("#newAssignmentModal").modal("show");
        }
      })
      .catch(() => {});
  };

  acknowledgeNewAssignments = () => {
    const alertIds = this.state.newAssignmentAlerts.map((a) => a.id);
    axios
      .post(`${apiUrl}api/users/ackNewAssignments`, { alertIds })
      .catch(() => {})
      .finally(() => {
        this.setState({ newAssignmentAlerts: [] });
        $("#newAssignmentModal").modal("hide");
      });
  };
  handleRowClick(event) {
    const target = event.target;
    // Check if the click happened on the specific columns (2, 3, or 4)
    if (target.closest("td:nth-child(2), td:nth-child(3), td:nth-child(4)")) {
      const row = target.closest("tr");
      const urlElement = row.querySelector(".patientLink");
      const url = urlElement ? urlElement.value : ""; // Avoid optional chaining
      // Check if a URL exists and navigate to it
      if (url && url.trim() !== "") {
        window.location.href = url;
      }
    }
  }

  // Current table render (the priority-grouped one) has no hidden
  // .patientLink input for handleRowClick to read, so clicking a row did
  // nothing. This computes the link straight from the row data instead —
  // same rule as the original: report_status >= 2 opens the chart/verify
  // screen; otherwise (still analyzing) opens the unanalysed-data view.
  navigateToPatient(row) {
    if (!row || !row._id || row.LastDatasetId === undefined) return;
    const backupOk = row.backup_status === 0 || row.backup_status === undefined;
    if (!backupOk) return;
    const url =
      row.report_status >= 2
        ? `/verifier-chart/${row._id}/${row.LastDatasetId}`
        : `/verifier-unanalysed/${row._id}/${row.LastDatasetId}`;
    window.location.href = url;
  }

  applyRowStyles() {
    const { rows } = this.state;

    if (rows) {
      // Directly modify styles in JSX instead of using jQuery
      const updatedRows = rows.map((row) => {
        const percentage = parseFloat(row.TimePercentage.props.children); // Get the percentage as a float

        let backgroundColor = "#8f8b8b"; // Default color
        if (percentage >= 50 && percentage <= 70) {
          backgroundColor = "#008080"; // Light green for percentage 50-60
        } else if (percentage >= 71 && percentage <= 90) {
          backgroundColor = "#2ecd99"; // Light yellow for percentage 71-90
        } else if (percentage >= 91 && percentage <= 100) {
          backgroundColor = "#e0544a"; // Dark yellow for percentage 91-100
        }

        // Return the updated row with a background color
        return { ...row, backgroundColor };
      });

      // Update state with the new rows including the background color
      this.setState({ rows: updatedRows });
    }
  }

  submitComment = async (e) => {
    const userid = e.currentTarget.id;
    const newText = (this.state.newComment || "").trim();
    if (!newText) return; // nothing to submit
    const verifiername = localStorage.getItem("verifiername") || "Unknown";
    const timestamp = new Date().toLocaleString("en-IN", { day: "2-digit", month: "short", hour: "2-digit", minute: "2-digit", hour12: true });
    const newEntry = `${newText} — ${verifiername} [${timestamp}]`;
    // Append new entry to existing history
    const existing = (this.state.comments || "").trim();
    const comments = existing ? `${existing}\n${newEntry}` : newEntry;

    try {
      await axios.post(`${apiUrl}api/patients/addComment/${userid}`, { comments });
      $(".closePopup").click();
      this.setState({ newComment: "", comments: "" });
      this.fetchData();
    } catch (error) {
      console.error("Error submitting comment:", error);
    }
  };
  handleSearchChange = (e) => {
    this.setState({ searchQuery: e.target.value });
  };
  filterRows = () => {
    const { rows, searchQuery, statusFilter, progressSnapshot } = this.state;
    let filtered = rows;

    // "Queue" sidebar link (?queue=1) — same page/table, but only this
    // verifier's own assigned patients. Type-10 only; myPatientIdSet comes
    // from /myAssignedPatientIds. Also restricted to AnalyzeCompleted (6) —
    // a patient can be assigned before analysis finishes (self-service
    // Request grabs whatever's in the pool), but it isn't actually ready
    // to verify until analysis is done, so Not Analyzed/Analyzed rows
    // don't belong in the work queue yet.
    const locationSearch =
      (this.props.location && this.props.location.search) ||
      window.location.search ||
      "";
    const isQueueView = locationSearch.includes("queue=1");
    if (isQueueView) {
      const idSet = this.state.myPatientIdSet;
      filtered = filtered.filter(
        (row) => idSet && idSet.has(String(row._id)) && row.report_status === 6
      );
    }

    // Status filter logic using report_status directly — control is hidden
    // in the Queue view, so skip it there regardless of any stale value.
    if (isQueueView) {
      // no-op
    } else if (statusFilter === "Not Analyzed") {
      filtered = filtered.filter(function (row) {
        return !row.report_status || row.report_status === 0;
      });
    } else if (statusFilter === "Analysis Started") {
      filtered = filtered.filter((row) => {
        const rs = row.report_status;
        const pr = row.progress_raw || 0;
        const isAnalyzing = rs === 1 || ((rs === 2 || rs === 6) && pr > 0 && pr < 100);
        if (!isAnalyzing) return false;
        const snap = progressSnapshot[row._id];
        const isStuck = snap && (Date.now() - snap.lastUpdated > 5 * 60 * 1000);
        return !isStuck;
      });
    } else if (statusFilter === "Possible Stuck") {
      filtered = filtered.filter((row) => {
        const rs = row.report_status;
        const pr = row.progress_raw || 0;
        const isAnalyzing = rs === 1 || ((rs === 2 || rs === 6) && pr > 0 && pr < 100);
        if (!isAnalyzing) return false;
        const snap = progressSnapshot[row._id];
        return snap && (Date.now() - snap.lastUpdated > 5 * 60 * 1000);
      });
    } else if (statusFilter === "Analyze Completed") {
      filtered = filtered.filter(function (row) {
        return row.report_status === 2 || row.report_status === 6;
      });
    } else if (statusFilter === "Verification Completed") {
      filtered = filtered.filter(function (row) {
        return row.report_status === 3;
      });
    } else if (statusFilter === "In Preparation") {
      filtered = filtered.filter(function (row) {
        return row.report_status === 4;
      });
    } else if (statusFilter === "Report Completed") {
      filtered = filtered.filter(function (row) {
        return row.report_status === 5 || !!row.ReportGeneration;
      });
    }

    // Search filter logic — search by patient ID, name, date, distributor, doctor
    // Convert all values to string so numeric device_id fields are also matched
    if (searchQuery) {
      const q = searchQuery.toLowerCase();
      filtered = filtered.filter((row) => {
        const searchFields = [row.patientId, row.name, row.added_date, row.distributor, row.doctor_name];
        return searchFields.some(
          (value) => value != null && String(value).toLowerCase().includes(q)
        );
      });
    }
    return filtered;
  };

  // Method to apply styles to rows based on priority

  handleDoctorChange = (selectedOption) => {
    this.setState({ selectedDoctor: selectedOption });
    // console.log("Selected doctor:", selectedOption);
    // Perform any action needed with the selected doctor
  };

  async generateReport(reportstatus, userid) {
    //  const userid=e.currentTarget.id

    // console.log("generate event id:", userid);
    this.setState({ generatereportuserid: userid });
    if (reportstatus == "2" || reportstatus == "6") {
      const res = await axios.get(
        apiUrl + "api/common/patinentmenutreeNew?userid=" + userid
      );

      this.setState({ treemenu: res.data });

      this.setState({ isModalReportOpen: true });
    }
    if (reportstatus == "4") {
      const res = await axios.get(
        apiUrl + "api/common/patinentmenutreeNew?userid=" + userid
      );

      this.setState({ treemenu: res.data });
      this.setState({ isModalReportOpen: true });
    } else {
      this.setState({ isModalReportOpen: false });
    }
  }

  handleVerifierChange = (selectedOptions) => {
    this.setState({
      selectedVerifiers: selectedOptions || [], // Update selected verifiers or set empty array if none
    });
    // console.log("selected options", selectedOptions);
    // console.log(
    //   "selected verifier state",
    //   this.state.selectedVerifiers,
    //   this.state.selectedVerifierIds
    // );
  };

  handleModalComplete(id) {
    // console.log("id:", id);
    this.state.userid = id;
    // Patient name rides along so "+ Queue" in the analyze modal can show
    // a readable entry in the analysis-queue panel.
    const row = (this.state.rows || []).find((r) => r._id === id);
    this.setState({
      isModalCompleteOpen: true,
      patientName: (row && row.name) || this.state.patientName,
    });
  }

  resetModalComplete() {
    this.setState({ isModalCompleteOpen: false });
  }

  onSubmit = (e) => {
    e.preventDefault();

    const settings = {
      userid: this.state.userid,
      nor_minhr: this.state.nor_minhr,
      nor_maxhr: this.state.nor_maxhr,
      qtcformula: this.state.qtcformula,
      qtcvalue_min: this.state.qtcvalue_min,
      qtcvaluemax: this.state.qtcvaluemax,
      qrswidth_min: this.state.qrswidth_min,
      qrswidth_max: this.state.qrswidth_max,
      qrsamp_min: this.state.qrsamp_min,
      qrsamp_max: this.state.qrsamp_max,
      stelevation: this.state.stelevation,
      pwidth_min: this.state.pwidth_min,
      pwidth_max: this.state.pwidth_max,
      pamp_min: this.state.pamp_min,
      pamp_max: this.state.pamp_max,
      stdepression: this.state.stdepression,
      twidth_min: this.state.twidth_min,
      twidth_max: this.state.twidth_max,
      tamp_min: this.state.tamp_min,
      tamp_max: this.state.tamp_max,
      printerval_min: this.state.printerval_min,
      printerval_max: this.state.printerval_max,
      tachyhr_lower: this.state.tachyhr_lower,
      tachyhr_upper: this.state.tachyhr_upper,
      bradyhr_lower: this.state.bradyhr_lower,
      bradyhr_upper: this.state.bradyhr_upper,
      pauselength: this.state.pauselength,
      graph_gen: this.state.graph_gen,
    };

    // console.log(settings);
    axios
      .post(apiUrl + "api/patients/updateSettings", settings)
      .then((res) => {
        $("#closePopup").click();
        // console.log("onclick");
      })
      .catch((err) => {
        console.log(err);
      });
  };

  onSubmitInfo = (e) => {
    e.preventDefault();

    //   this.state.selectedVerifiers.forEach(verifier => {
    //     console.log("Verifier ID:", verifier.value);
    // });

    const info = {
      name: this.state.patient_name,
      patientid: this.state.userid,
      userid: this.state.userid,
      dob: this.state.dob,
      weight: this.state.weight,
      height: this.state.height,
      hospital: this.state.hospital,
      phone: this.state.phone,
      email: this.state.email_id,
      doctorid: this.state.selectedDoctor.value,
      ipop: this.state.ipop,
      fileType: this.state.filetype || "easy",
      verifierid: this.state.selectedVerifiers.map(
        (verifier) => verifier.value
      ),
      priority: Number(this.state.priority) || 4,

      reportstatus: this.state.reportstatus,
      // smoking: this.state.smoking,
      // diabetes: this.state.diabetes,
      af: this.state.af,
      // hyper_tension: this.state.hyper_tension,
      // hyper_lipidemia: this.state.hyper_lipidemia,
      hyper_lipidemia: this.state.pacemaker,
      indication: this.state.indication,
      cardiac_surgery: this.state.cardiac_surgery,
      thyroid: this.state.thyroid_function,
      exp_device_use_days: this.state.duration,
      issueReported: this.state.issueReport,
      supportLevel: this.state.supportLevel,
      supportPerson: this.state.supportPerson,
      supportcomment: this.state.supportedMatter,
      prioritizeData: this.state.prioritizeData, // <-- Add this line
      clinicalCondition: this.state.clinicalCondition, // <-- Add this line
      // Customer selected from the dropdown. customerName is the display value
      // (matches VerifierHome's DistributorName column); customerId is the
      // canonical link. Backend updateInfo_new_info_test must persist both.
      customerName: this.state.customer_details || "",
      customerId: this.state.customerId || "",
    };
    // console.log("info:", this.state.clinicalCondition);

    // Priority is now patient-level only. We no longer mirror it onto the
    // device (`updateDevicePriority`), since that coupled the patient's
    // urgency to the device assignment and produced stale priorities when
    // devices were reassigned or deactivated.
    axios
      .post(apiUrl + "api/patients/updateInfo_new_info_test", info)
      .then(() => {
        // Graphs To Be Generated lives in a separate UserSetting document —
        // save it alongside the main patient info via the endpoint already
        // used elsewhere for this same field. Failure here shouldn't block
        // closing the modal; the rest of the patient info already saved.
        axios
          .post(apiUrl + "api/patients/updateSettings", {
            userid: this.state.userid,
            graph_gen: this.state.graph_gen,
          })
          .catch((err) => {
            console.error("Error saving graph_gen:", err);
          });
        $(".closePopup").click();
        this.fetchData();
      })
      .catch((err) => {
        console.error("Error occurred:", err);
      });
  };

  onChange = (e) => {
    var err = this.state.errors;
    delete err[e.target.name];
    // console.log("onChange");
    // console.log(e.target.name);
    // console.log(e.target.value);
    // console.log(e.target)
    // this.setState({reportstatus:e.target.value})
    // console.log(e.target.value)

    this.setState({ [e.target.name]: e.target.value });
  };
  handleTypeChange = (e) => {
    // console.log("e.target.value", e.target.value);
    this.setState({ filetype: e.target.value });
  };
  handleDateChange = (inputDate) => {
    let formattedDate = inputDate;
    if (
      inputDate &&
      typeof inputDate === "object" &&
      inputDate._isAMomentObject
    ) {
      // If using moment.js object from Datetime
      formattedDate = inputDate.format("MM/DD/YYYY");
    } else if (inputDate instanceof Date && !isNaN(inputDate.getTime())) {
      // If using native Date object
      const mm = String(inputDate.getMonth() + 1).padStart(2, "0");
      const dd = String(inputDate.getDate()).padStart(2, "0");
      const yyyy = inputDate.getFullYear();
      formattedDate = `${mm}/${dd}/${yyyy}`;
    } else if (typeof inputDate === "string") {
      // If string, try to parse as date
      const dateObj = new Date(inputDate);
      if (!isNaN(dateObj.getTime())) {
        const mm = String(dateObj.getMonth() + 1).padStart(2, "0");
        const dd = String(dateObj.getDate()).padStart(2, "0");
        const yyyy = dateObj.getFullYear();
        formattedDate = `${mm}/${dd}/${yyyy}`;
      } else {
        formattedDate = inputDate;
      }
    }
    this.setState({ dob: formattedDate });
  };

  onIpOpChange = (e) => {
    console.log("ipop", e.target.value);
    this.setState({ ipop: e.target.value });
  };
  onDurationChange = (e) => {
    var err = this.state.errors;
    delete err[e.target.name];
    this.setState({ duration: e.target.value });
    console.log(this.state.duration);
  };
  onPriorityChange = (e) => {
    var err = this.state.errors;
    delete err[e.target.name];

    // console.log(e.target.value)
    this.setState({ priority: e.target.value });
  };
  onReportStatuschange = (e) => {
    // console.log("report stats change",e.target.value)
    this.setState({ reportstatus: e.target.value });
  };
  onGenderChange = (e) => {
    this.setState({ gender: e.target.value });
  };

  // Load the customer/distributor list for the edit modal's Customer dropdown.
  // Fetched lazily (only when the modal first needs it) and cached in state so
  // reopening the modal doesn't re-hit the server — keeps outbound traffic low.
  loadCustomerList = () => {
    if (this.state.customerList && this.state.customerList.length) return; // cached
    axios
      .get(`${apiUrl}api/users/getCustomerNames`)
      .then((res) => {
        let data = res.data;
        if (!Array.isArray(data)) {
          if (data && Array.isArray(data.data)) data = data.data;
          else if (data && Array.isArray(data.result)) data = data.result;
          else data = [];
        }
        const list = data
          .filter((it) => it && (it.customerId || it.customer_id || it._id))
          .map((it) => ({
            id: String(it.customerId || it.customer_id || it._id),
            name: it.name || it.customer_details || it.customer_name || "",
          }))
          .filter((it) => it.name);
        // De-dupe by name, then sort alphabetically for a tidy dropdown.
        const seen = {};
        const uniq = [];
        list.forEach((it) => {
          const k = it.name.toUpperCase();
          if (!seen[k]) { seen[k] = true; uniq.push(it); }
        });
        uniq.sort((a, b) => a.name.localeCompare(b.name));
        this.setState({ customerList: uniq });
      })
      .catch((e) => console.warn("[patient-list] customer list load failed:", e.message));
  };

  // Customer dropdown selection → keep both the display name and the id, so the
  // save payload can send customerName (display) + customerId (canonical link).
  onCustomerChange = (opt) => {
    this.setState({
      customer_details: opt ? opt.label : "",
      customerId: opt ? String(opt.value) : "",
    });
  };

  preventDefault(e) {
    e.preventDefault();
  }
  HandleVerifiedSpeed(e) {
    console.log(e.target.value);
  }
  getInfo(e) {
    this.setState({
      smoking: "",
      diabetes: "",
      af: "",
      hyper_tension: "",
      hyper_lipidemia: "",
      indication: "",
      cardiac_surgery: "",
      thyroid_function: "",
      loadingEditModal: true, // Set loading to true when starting
      supportPerson: "",
      supportLevel: "",
      supportedMatter: "",
    });
    this.setState({ isModalCompleteOpen: false });
    this.loadCustomerList(); // populate the Customer dropdown (cached after first load)
    var userid = e.currentTarget.id;
    const dataid2 = e.target.getAttribute("dataid2");
    const dataid3 = e.target.getAttribute("dataid3");
    this.setState({ userid: userid });
    // Graphs To Be Generated lives in UserSetting, not on the Patient
    // document — fetch it separately so the Edit Patient modal shows the
    // value actually saved, not whatever was left in state from before.
    axios
      .get(`${apiUrl}api/patients/settings?userid=${userid}`)
      .then((res) => {
        this.setState({ graph_gen: (res.data && res.data.graph_gen) || "" });
      })
      .catch(() => {
        this.setState({ graph_gen: "" });
      });
    axios
      .get(`${apiUrl}api/patients/getPatinetAdditionalInfo?userid=${userid}`)
      .then((res) => {
        const data = res.data[0];
        if (
          data.gender === "MALE" ||
          data.gender === "male" ||
          data.gender === "Male" ||
          data.gender === "M" ||
          data.gender === "m"
        ) {
          this.setState({ gender: "M" });
        }

        if (
          data.gender === "FEMALE" ||
          data.gender === "female" ||
          data.gender === "Female" ||
          data.gender === "F" ||
          data.gender === "f"
        ) {
          this.setState({ gender: "F" });
        }
        if (data.gender === "Select Gender") {
          this.setState({ gender: "M" });
        }

        if (Array.isArray(this.state.patients)) {
          this.state.patients.forEach((patient) => {
            if (patient._id === userid) {
              this.setState({ reportstatus: patient.report_status });
              // console.log("report status", patient.report_status);
            }
          });
        }
        if (Array.isArray(data.customer_details)) {
          data.customer_details.forEach((customer) => {
            if (customer.customer_details) {
              // console.log('Nested Customer Details:', customer);
              this.setState({ customer_details: customer.customer_details });
            }
          });
        }
        // console.log(this.state.patients);
        console.log("additional data!!!!!!!!!!!!!!!", data);
        // Update state with patient info
        this.setState({
          af: data.af ? "yes" : "no",
          duration: data.exp_device_use_days,
          cardiac_surgery: data.cardiac_surgery ? "yes" : "no",
          thyroid_function: data.thyroid,
          diabetes: data.diabetes,
          indication: data.indication,
          height: data.height,
          weight: data.weight,
          hospital: data.hospital,
          phone: data.phone,
          patient_name: data.name,
          email_id: data.email,
          selectedDoctor: { value: data.doctor_id, label: data.doctor_name },
          macid: dataid2,
          priority: dataid3 && Number(dataid3) <= 4 ? String(dataid3) : "4",
          dob: data.dob,
          duration: data.exp_device_use_days,
          filetype: data.fileType,
          pacemaker: data.hyper_lipidemia,
          issueReport: data.issueReported,
          Confirmation: data.Confirmation,
          supportedMatter: data.supportcomment,
          supportPerson: data.supportPerson,
          supportLevel: data.supportLevel,
          prioritizeData: data.priorityStatus || "No",
          clinicalCondition: data.clinicalCondition || "", // <-- Add this line
          // Preselect the patient's current customer in the dropdown. Prefer the
          // patient-level customerName; fall back to the customer_details set
          // above from the device record. customerId links it canonically.
          customer_details:
            data.customerName ||
            data.customer_name ||
            this.state.customer_details ||
            "",
          customerId: String(data.customerId || data.customer_id || ""),
        });
        // console.log("clinical condition:", data.clinicalCondition);
        // Handle DOB formatting
        let formattedDob = data.dob;
        if (formattedDob) {
          // Convert ISO string or YYYY-MM-DD to MM/DD/YYYY for display
          const dateObj = new Date(formattedDob);
          if (!isNaN(dateObj.getTime())) {
            const mm = String(dateObj.getMonth() + 1).padStart(2, "0");
            const dd = String(dateObj.getDate()).padStart(2, "0");
            const yyyy = dateObj.getFullYear();
            formattedDob = `${mm}/${dd}/${yyyy}`;
          }
        }
        this.setState({ dob: formattedDob });

        // Set age from DOB
        const age = this.calculateAgeFromDOB(data.dob);
        this.setState({ age });

        // Second API call for verifiers
        return axios.get(`${apiUrl}api/users/allverifiers`);
      })
      .then((res) => {
        const verifiers = res.data;
        const formattedVerifiers = verifiers.map((verifier) => ({
          value: verifier._id,
          label: verifier.name,
          patients: verifier.patients, // Assuming patients is an array of user IDs
        }));

        const filteredVerifiers = formattedVerifiers.filter((verifier) =>
          verifier.patients.includes(userid)
        );

        // console.log('Filtered verifiers with matching user:', this.state.priority);

        this.setState({ selectedVerifiers: filteredVerifiers });

        this.setState({ verifiers: formattedVerifiers });
        // console.log('formatted verifiers:',verifiers)
        // Third API call for patient search (ipop)
        this.state.patients.forEach((patient) => {
          if (patient._id === userid) {
            this.setState({ comments: patient.comments });
            // this.setState({ priority: patient.priority });
            this.setState({ ipop: patient.ip_op });
          }
        });

        // console.log("ipop", this.state.patients);

        // Fourth API call for verified percentage
        return axios.get(`${apiUrl}api/users/getVerifiedPercentage/${userid}`);
      })
      .then((res) => {
        const ecgValues = res.data.ecgValues; // Assuming `ecgValues` is an array
        const totalLength = ecgValues.length;
        let verifyCount = 0; // Initialize verify count

        ecgValues.forEach((value, index) => {
          if (value.verifyStatus === 1) {
            // console.log(`Link for ECG value at index ${index}:`, value.link); // Assuming there's a 'link' property
            verifyCount++; // Increment the verify count
          }
        });

        // console.log('Total verified ECG values:', verifyCount);
        // console.log('Total count:', totalLength);

        if (totalLength > 0) {
          // console.log('ECG data is available.');

          // Calculate and log the percentage of verified ECG values
          const percentageVerified = (verifyCount / totalLength) * 100;
          // console.log('Percentage of verified ECG values:', percentageVerified.toFixed(2) + '%');
          this.setState({ percentageVerified: percentageVerified.toFixed(2) });
          // console.log('verified percentage:',this.state.percentageVerified)
        } else {
          // console.log('No ECG data found.');
        }
        this.setState({ loadingEditModal: false }); // Data loaded, hide spinner
        axios.get(`${apiUrl}api/common/getSupportPerson`).then((res) => {
          if (res.data && Array.isArray(res.data)) {
            this.setState({ supportPersons: res.data });
            // console.log("support persons:!!!!!!!!!!!!!!!!!!!!!!", this.state.supportPersons);
          }
        });
      })

      .catch((error) => {
        console.error("Error fetching ECG data:", error);
        this.setState({ loadingEditModal: false }); // Hide spinner on error
      });
  }
  getverifiedprogress(e) {
    this.setState({ isModalCompleteOpen: false });
    this.setState({
      smoking: "",
      diabetes: "",
      af: "",
      hyper_tension: "",
      hyper_lipidemia: "",
      indication: "",
      cardiac_surgery: "",
      thyroid_function: "",
      hourstocompleted: "",
      selectedVerifiersEfficency: [],
      loadingVerifierProgress: true,
    });

    var userid = e.currentTarget.id;
    const dataid2 = e.target.getAttribute("dataid2");
    const dataid3 = e.target.getAttribute("dataid3");
    const hourstocompleted = e.target.getAttribute("hourcomplete");
    this.setState({ hourstocompleted: hourstocompleted });

    // console.log("current target", hourstocompleted);
    this.setState({ userid: userid });

    axios
      .get(`${apiUrl}api/patients/getPatinetAdditionalInfo?userid=${userid}`)
      .then((res) => {
        const data = res.data[0];

        if (Array.isArray(this.state.patients)) {
          this.state.patients.forEach((patient) => {
            if (patient._id === userid) {
              this.setState({ reportstatus: patient.report_status });
              // console.log("report status", patient.report_status);
            }
          });
        }
        if (Array.isArray(data.customer_details)) {
          data.customer_details.forEach((customer) => {
            if (customer.customer_details) {
              // console.log('Nested Customer Details:', customer);
              this.setState({ customer_details: customer.customer_details });
            }
          });
        }
        // console.log(this.state.patients);

        // Update state with patient info
        this.setState({
          af: data.af ? "yes" : "no",
          duration: data.exp_device_use_days,
          cardiac_surgery: data.cardiac_surgery ? "yes" : "no",
          thyroid_function: data.thyroid,
          diabetes: data.diabetes,
          indication: data.indication,
          height: data.height,
          weight: data.weight,
          hospital: data.hospital,
          phone: data.phone,
          patient_name: data.name,
          email_id: data.email,
          selectedDoctor: { value: data.doctor_id, label: data.doctor_name },
          macid: dataid2,
          priority: dataid3 && Number(dataid3) <= 4 ? String(dataid3) : "4",
          dob: data.dob,
          duration: data.exp_device_use_days,
          filetype: data.fileType,
        });

        // Handle DOB formatting
        const dob = new Date(Date.parse(data.dob));
        const formattedDob = `${dob.getMonth() + 1
          }/${dob.getDate()}/${dob.getFullYear()}`;
        this.setState({ dob: formattedDob });

        // Second API call for verifiers
        return axios.get(`${apiUrl}api/users/allverifiers_new`);
      })
      .then((res) => {
        const verifiers = res.data;
        const formattedVerifiers = verifiers.map((verifier) => ({
          value: verifier._id,
          label: verifier.name,
          patients: verifier.patients, // Assuming patients is an array of user IDs
        }));

        // NOTE: selectedVerifiers is NOT filtered by `verifier.patients`
        // here — that array is the live assignment list, which gets
        // cleaned up / changed after a verifier finishes (see
        // cleanupStaleAssignments on the backend). Gating on it hid real
        // past verification activity for any verifier no longer carrying
        // this patient in their `patients` array. The actual filter to
        // "who verified this patient" happens below, once ecgValues (the
        // real activity record) comes back.
        this.setState({ verifiers: formattedVerifiers });
        // console.log('formatted verifiers:',verifiers)
        // Third API call for patient search (ipop)
        this.state.patients.forEach((patient) => {
          if (patient._id === userid) {
            this.setState({ comments: patient.comments });
            // this.setState({ priority: patient.priority });
            this.setState({ ipop: patient.ip_op });
          }
        });

        // console.log("ipop", this.state.patients);

        // Fourth API call for verified percentage
        return axios.get(`${apiUrl}api/users/getVerifiedPercentage/${userid}`);
      })
      .then((res) => {
        const ecgValues = res.data.ecgValues; // Assuming `ecgValues` is an array
        // Build selectedVerifiers from WHO ACTUALLY VERIFIED this patient
        // (ecgValues.verifierId), not from whose `patients` array still
        // happens to list this patient — the latter is stale/incomplete
        // once an assignment is cleaned up or was made via verifier_blocks
        // without ever touching `patients`.
        //
        // Previously this FILTERED allverifiers_new down to whoever's ID
        // also appears in ecgValues — which meant a verifier whose account
        // was since deleted, merged into another account, or had its type
        // changed away from the allverifiers_new query (2/8/10) would
        // vanish from this popup entirely, with their real verified work
        // just missing — not merged into anyone else's count, invisible.
        // Build the list from the activity itself instead, and only use
        // allverifiers_new to resolve a display name — unresolvable IDs
        // still show up, just labeled, so no real work disappears.
        const activeVerifierIds = Array.from(
          new Set((ecgValues || []).map((ecg) => ecg.verifierId).filter(Boolean))
        );
        const allVerifiers = this.state.verifiers || [];
        const verifierById = {};
        allVerifiers.forEach((v) => { verifierById[v.value] = v; });
        const selectedVerifiers = activeVerifierIds.map(
          (id) => verifierById[id] || { value: id, label: `Unknown verifier (${id})`, patients: [] }
        );
        this.setState({ selectedVerifiers: selectedVerifiers });
        const fileType = this.state.filetype || "easy"; // 'easy', 'medium', 'hard'

        const allowedTimePerECGInMinutes =
          fileType === "easy" ? 4 : fileType === "medium" ? 6 : 9;

        const verifierEfficiencyResults = [];

        if (selectedVerifiers && selectedVerifiers.length > 0) {
          // Track outstanding per-verifier POSTs so we can flip off the loading
          // spinner only after every verifier has finished computing.
          let pendingVerifierFetches = 0;
          const markFetchDone = () => {
            pendingVerifierFetches--;
            if (pendingVerifierFetches <= 0) {
              this.setState({ loadingVerifierProgress: false });
            }
          };

          // Pre-count verifiers that will actually trigger an API call.
          selectedVerifiers.forEach((verifier) => {
            const hasFiles = ecgValues.some(
              (ecg) => ecg.verifierId === verifier.value
            );
            if (hasFiles) pendingVerifierFetches++;
          });
          // No verifier had any files → nothing will fire, finish immediately.
          if (pendingVerifierFetches === 0) {
            this.setState({ loadingVerifierProgress: false });
          }

          selectedVerifiers.forEach((verifier) => {
            const filteredECGValues = ecgValues
              .filter((ecg) => ecg.verifierId === verifier.value)
              .sort((a, b) => new Date(a.verifyTime) - new Date(b.verifyTime));

            if (filteredECGValues.length > 0) {
              // Here you can extract any data you need from `filteredECGValues` and pass it as a parameter
              // Assuming we are passing the `filteredECGValues` directly or extracting an ID or relevant data for `databaseid`
              const databaseId = filteredECGValues
                .map((ecg) => ecg.ecgvalue_id)
                .join(","); // Assuming `id` is the relevant field

              axios
                .post(
                  `${apiUrl}api/common/getTotalStripCount?userid=${userid}&databaseid=${databaseId}`
                )
                .then((apiResponse) => {
                  const startTime = new Date(filteredECGValues[0].verifyTime);
                  const endTime = new Date(
                    filteredECGValues[filteredECGValues.length - 1].verifyTime
                  );

                  // "Time spent" = wall-clock duration from the verifier's
                  // FIRST verification tick to their LAST verification tick.
                  // (Previously this was derived from getTotalStripCount,
                  // which represents recording duration, not verifier effort,
                  // and produced misleading values like "12Hrs:12Mins".)
                  const elapsedMs = Math.max(0, endTime - startTime);
                  const elapsedMinutes = Math.round(elapsedMs / 60000);
                  const hours = Math.floor(elapsedMinutes / 60);
                  const minutes = elapsedMinutes % 60;
                  const formattedTime = `${hours}Hrs:${minutes
                    .toString()
                    .padStart(2, "0")}Mins`;

                  // "Files done" = total verifications this verifier marked
                  // on this patient. Previously we showed the count of
                  // efficient deltas, which under-counted by one and was
                  // confusing.
                  const filesDone = filteredECGValues.length;

                  // "Avg / file" = wall-clock time per file =
                  // Time spent / Files done. This matches what users see
                  // in the modal: if a verifier worked 2h 23m and
                  // completed 4 files, that's 35.75 min/file — NOT the
                  // 0.6 min "average click delta" the old formula gave.
                  const averageTimePerECG =
                    filesDone > 0 ? elapsedMinutes / filesDone : 0;

                  // "Efficiency" = % of CONSECUTIVE verifies completed
                  // within the allowed per-file budget (4/6/9 min by
                  // difficulty). Kept as a separate "in-the-moment
                  // throughput" metric — independent from the wall-clock
                  // per-file average above.
                  let efficientDeltas = 0;
                  let comparisons = 0;
                  let totalTimeSpentInMinutes = 0;
                  const MAX_GAP_MINUTES = 10;
                  filteredECGValues.forEach((ecg, index) => {
                    if (index > 0) {
                      const prevVerifyTime = new Date(
                        filteredECGValues[index - 1].verifyTime
                      );
                      const currentVerifyTime = new Date(ecg.verifyTime);
                      const timeDifferenceInMinutes =
                        (currentVerifyTime - prevVerifyTime) / (1000 * 60);
                      if (
                        timeDifferenceInMinutes > 0 &&
                        timeDifferenceInMinutes <= MAX_GAP_MINUTES
                      ) {
                        comparisons++;
                        totalTimeSpentInMinutes += timeDifferenceInMinutes;
                        if (
                          timeDifferenceInMinutes <= allowedTimePerECGInMinutes
                        ) {
                          efficientDeltas++;
                        }
                      }
                    }
                  });

                  const efficiency =
                    comparisons > 0
                      ? (efficientDeltas / comparisons) * 100
                      : 0;
                  const remainingECGCount =
                    ecgValues.length - filteredECGValues.length;
                  const estimatedRemainingTime =
                    averageTimePerECG * remainingECGCount;

                  verifierEfficiencyResults.push({
                    label: verifier.value,
                    value: efficiency.toFixed(2),
                    averageTimePerECG: averageTimePerECG.toFixed(2),
                    estimatedRemainingTime: estimatedRemainingTime.toFixed(2),
                    startTime: startTime.toISOString(),
                    endTime: endTime.toISOString(),
                    totalTimeSpentInMinutes: totalTimeSpentInMinutes || "N/A",
                    totalSpendHours: formattedTime || "N/A",
                    // Modal reads `totalEfficientCount` for "Files done";
                    // semantically this is now "files done" (total
                    // verifications), kept under the legacy field name to
                    // avoid a JSX change for the rendered cell.
                    totalEfficientCount: filesDone,
                    filesDone,
                  });

                  this.setState({
                    selectedVerifiersEfficency: verifierEfficiencyResults,
                  });
                  markFetchDone();
                })
                .catch((err) => {
                  console.error("Error fetching data from API", err);
                  markFetchDone();
                });
            } else {
              console.log(
                `No ECG values found for Verifier ID: ${verifier.value}`
              );
            }
          });
        } else {
          console.log("No selected verifiers found.");
          this.setState({ loadingVerifierProgress: false });
        }

        const totalLength = ecgValues.length;
        let verifyCount = 0;

        ecgValues.forEach((value) => {
          if (value.verifyStatus === 1) {
            verifyCount++;
          }
        });

        if (totalLength > 0) {
          const percentageVerified = (verifyCount / totalLength) * 100;
          this.setState({ percentageVerified: percentageVerified.toFixed(2) });
        }
      })

      .catch((error) => {
        console.error("Error fetching ECG data:", error);
        this.setState({ loadingVerifierProgress: false });
      });
  }
  getConfirmTime(e) {
    console.log(e.currentTarget.id);
    const userid = e.currentTarget.id;
    const now = new Date();
    const updatedDate = `${now.getFullYear()}-${String(
      now.getMonth() + 1
    ).padStart(2, "0")}-${String(now.getDate()).padStart(2, "0")} ${String(
      now.getHours()
    ).padStart(2, "0")}:${String(now.getMinutes()).padStart(2, "0")}:${String(
      now.getSeconds()
    ).padStart(2, "0")}`;

    console.log("Clicked date and time:", updatedDate);

    // Make the API call
    axios.post(`${apiUrl}api/patients/updateUpdateDate`,{
      userid:userid,
      updatedDate:updatedDate
     })
     .then((res) => { 
      console.log("Date updated successfully:", res.data);
      this.fetchData(); // Refresh data after update
     })
     .catch((err) => {
      console.error("Error updating date:", err);
    })
   
  }

  // Open priority modal with patient context
  openPriorityModal = (e, opts) => {
    const { userid, macid, priority, confirmDate } = opts || {};
    
    // Always use today's date with 00:00:00 as default
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, "0");
    const day = String(today.getDate()).padStart(2, "0");
     const hours = String(today.getHours()).padStart(2, "0");
    const minutes = String(today.getMinutes()).padStart(2, "0");
    const seconds = String(today.getSeconds()).padStart(2, "0");

   
    const modalDateTime = `${year}-${month}-${day}T${hours}:${minutes}:${seconds}`;
    
    this.setState({
      modalPatientId: userid,
      modalMacid: macid || null,
      modalPriority: priority || "", // empty = unprioritised, nothing pre-selected
      modalDateTime,
    });
  };

  closePriorityModal = () => {
    this.setState({
      modalPatientId: null,
      modalMacid: null,
      modalPriority: "",
      modalDateTime: "",
    });
  };

  handlePriorityChange = (e) => {
    this.setState({ modalPriority: e.target.value });
  };

  handlePriorityDateChange = () => {
    // kept for compatibility
  };

  savePriorityChange = () => {
    const { modalPriority, modalPatientId, modalDateTime } = this.state;
    const requests = [];

    // Priority is now patient-driven only. We no longer write to the device,
    // so a device reassignment / deactivation never silently changes the
    // priority of the patient who was prioritized.
    // Only write when the user actually picked something: High/Moderate/
    // Simple (1/2/3) or None (4 = clear back to unprioritised). An empty
    // selection means "leave priority as-is" — no fabricated default.
    if (modalPatientId && ["1", "2", "3", "4"].includes(String(modalPriority))) {
      requests.push(
        axios.put(`${apiUrl}api/patients/updatePatientPriority`, {
          patient_id: modalPatientId,
          priority: modalPriority,
        })
      );
    }

    // Update the confirm/updated date shown in the table
    if (modalDateTime && modalPatientId) {
      const combinedDateTime = modalDateTime.replace("T", " ") + (modalDateTime.length === 16 ? ":00" : "");
      requests.push(
        axios.post(`${apiUrl}api/patients/updateUpdateDate`, {
          userid: modalPatientId,
          updatedDate: combinedDateTime,
        })
      );
    }

    if (requests.length === 0) {
      toast.error("Nothing to save — no patient selected.");
      return;
    }

    Promise.all(requests)
      .then(() => {
        this.closePriorityModal();
        this.fetchData();
        toast.success("Priority updated");
      })
      .catch((err) => {
        console.error(err);
        toast.error("Failed to update priority");
      });
  };

  selectItem(e) {
    var userid = e.currentTarget.id;
    this.setState({ userid: userid });
    this.setState({
      nor_minhr: "",
      nor_maxhr: "",
      qtcformula: "",
      qtcvalue_min: "",
      qtcvaluemax: "",
      qrswidth_min: "",
      qrswidth_max: "",
      qrsamp_min: "",
      qrsamp_max: "",
      stelevation: "",
      pwidth_min: "",
      pwidth_max: "",
      pamp_min: "",
      pamp_max: "",
      stdepression: "",
      twidth_min: "",
      twidth_max: "",
      printerval_min: "",
      printerval_max: "",
      tachyhr_lower: "",
      tachyhr_upper: "",
      bradyhr_lower: "",
      bradyhr_upper: "",
      pauselength: "",
      graph_gen: "",
    });
    axios
      .get(apiUrl + "api/patients/settings?userid=" + userid)
      .then((res) => {
        var data = res.data;
        this.setState(data);
      })
      .catch((err) => {
        console.log(err);
      });
  }

  resetModalReport() {
    // console.log("resetmodal clicked!!!");
    this.setState({ isModalReportOpen: false });
    this.fetchData();
  }
  resetInfoModal() {
    this.setState({
      smoking: "",
      diabetes: "",
      af: "",
      hyper_tension: "",
      hyper_lipidemia: "",
      indication: "",
      cardiac_surgery: "",
      thyroid_function: "",
      customer_details: "", // Reset customer details too
      reportstatus: "",
      dob: "",
      height: "",
      weight: "",
      hospital: "",
      phone: "",
      patient_name: "",
      email_id: "",
      doctor_name: "",
      doctor_id: "",
      duration: "",
      selectedVerifiers: [],
      verifiers: [],
      comments: "",
      priority: "4",
      ipop: "",
      percentageVerified: "",
      macid: "",
      filetype: "",
      hourstocompleted: "",
      isConfirmationModalOpen: false,
      selectedConfirmation: "",
      loadingEditModal: false,
      newComment: "",
      comments: "",
    });
    // console.log(this.state.verifiers);
  }
  handleConfirmationClick = () => {
    this.setState({
      isConfirmationModalOpen: true,
      selectedConfirmation: this.state.Confirmation,
    });
  };

  handleConfirmationChange = (e) => {
    this.setState({ selectedConfirmation: e.target.value });
  };

  handleConfirmationSubmit = async () => {
    try {
      await axios.post(`${apiUrl}api/patients/updateConfirmation`, {
        userid: this.state.userid,
        Confirmation: this.state.selectedConfirmation,
      });
      toast.success(
        `Confirmation Updated to: ${this.state.selectedConfirmation}`
      );
      this.setState({
        Confirmation: this.state.selectedConfirmation,
        isConfirmationModalOpen: false,
      });
      this.fetchData();
    } catch (error) {
      console.error("Error updating confirmation:", error);
    }
  };

  handleConfirmationCancel = () => {
    this.setState({ isConfirmationModalOpen: false });
  };

  // TAT notification methods
  checkTatNotifications = () => {
    const {
      patients,
      tatNotifications,
      isShowingNotification,
      notificationQueue,
    } = this.state;
    const currentTime = new Date();
    const newNotifications = [];

    patients.forEach((patient) => {
      const patientId = patient._id;
      const Priority = getPatientPriority(patient);

      // Calculate time limit based on priority
      let timeLimit;
      switch (Priority) {
        case 1:
          timeLimit = 1;
          break;
        case 2:
          timeLimit = 2;
          break;
        case 3:
          timeLimit = 3;
          break;
        case 4:
          timeLimit = 4;
          break;
        case 5:
          timeLimit = 5;
          break;
        default:
          timeLimit = 4;
      }

      // Get the final time for calculation
      let finalTime;
      if (patient.ConfirmupdatedDate) {
        let confirmButtonTime = patient.ConfirmupdatedDate.split("T");
        let confirmDate = confirmButtonTime[0];
        let confirmTime = confirmButtonTime[1]
          ? confirmButtonTime[1].split("Z")[0]
          : "";
        if (confirmTime) {
          let time = confirmTime.split(".")[0]; // Get time without milliseconds
          finalTime = confirmDate + " " + time;
        }
      } else if (patient.updatedDate) {
        let updatedDateTime = patient.updatedDate.split(" ");
        let updatedDate = updatedDateTime[0];
        let updatedTime = updatedDateTime[1];
        finalTime = updatedDate + " " + updatedTime;
      }

      if (finalTime) {
        const finalDate = new Date(finalTime);

        // Skip if date is invalid
        if (isNaN(finalDate.getTime())) {
          return;
        }

        const timeDifference = currentTime - finalDate;
        const hoursDifference = timeDifference / (1000 * 60 * 60);

        // Skip if time difference is negative (future date) or invalid
        if (hoursDifference < 0 || isNaN(hoursDifference)) {
          return;
        }

        let exp_device =
          patient.exp_device_use_days === 24
            ? 1
            : patient.exp_device_use_days === 48
              ? 2
              : patient.exp_device_use_days === 72
                ? 3
                : patient.exp_device_use_days;

        const timePercentage = Math.min(
          (hoursDifference / (timeLimit * exp_device)) * 100,
          100
        );

        // Calculate remaining time
        const completionRate = timePercentage / hoursDifference;
        const totalCompletionTime = 100 / completionRate;
        const remainingTimeInHours = totalCompletionTime - hoursDifference;
        const remainingTimeInMinutes = remainingTimeInHours * 60;
        const hours = Math.floor(remainingTimeInMinutes / 60);
        const minutes = Math.round(remainingTimeInMinutes % 60);

        // Handle edge case where completion rate is 0 or negative
        if (
          completionRate <= 0 ||
          isNaN(completionRate) ||
          !isFinite(completionRate)
        ) {
          return; // Skip this patient if calculation is invalid
        }

        // Check if we should show notification
        const notificationKey = `${patientId}_${timePercentage >= 100 ? "completed" : "warning"
          }`;

        // if (!tatNotifications.has(notificationKey)) {
        //   if (timePercentage >= 100) {
        //     // TAT completed - add to notification queue
        //     newNotifications.push({
        //       type: "error",
        //       message: `⏰ TAT Time's Up! Patient ${patient.name} (${patient.device_id}) - Priority ${Priority} has exceeded the time limit.`,
        //       patientId: patientId,
        //       notificationKey: notificationKey,
        //     });
        //     // console.log(
        //     //   "TAT Time's Up! Patient",
        //     //   patient.name,
        //     //   "(" +
        //     //     patient.device_id +
        //     //     ")" +
        //     //     " - Priority " +
        //     //     Priority +
        //     //     " has exceeded the time limit."
        //     // );
        //   } else if (timePercentage >= 90) {
        //     // TAT approaching completion - add to notification queue
        //     newNotifications.push({
        //       type: "warning",
        //       message: `⚠️ TAT Alert! Patient ${patient.name} (${
        //         patient.device_id
        //       }) - Priority ${Priority} is at ${timePercentage.toFixed(
        //       }) - Priority ${Priority} is at ${timePercentage.toFixed(
        //         1
        //       )}% completion. Remaining time: ${hours}h ${minutes}m`,
        //       patientId: patientId,
        //       notificationKey: notificationKey,
        //     });
        //   }
        // }
      }
    });

    // Add new notifications to queue and process them
    if (newNotifications.length > 0) {
      const updatedQueue = [...notificationQueue, ...newNotifications];
      this.setState(
        {
          notificationQueue: updatedQueue,
          tatNotifications: new Set([
            ...tatNotifications,
            ...newNotifications.map((n) => n.notificationKey),
          ]),
          lastTatCheck: currentTime,
        },
        () => {
          this.processNotificationQueue();
        }
      );
    } else {
      this.setState({
        tatNotifications: new Set(tatNotifications),
        lastTatCheck: currentTime,
      });
    }
  };

  // Process notification queue - shows one notification at a time
  processNotificationQueue = () => {
    const { notificationQueue, isShowingNotification } = this.state;

    if (isShowingNotification || notificationQueue.length === 0) {
      return;
    }

    const nextNotification = notificationQueue[0];
    const remainingQueue = notificationQueue.slice(1);

    this.setState({
      isShowingNotification: true,
      notificationQueue: remainingQueue,
    });

    // Show the notification
    if (nextNotification.type === "error") {
      toast.error(nextNotification.message, {
        duration: 5000,
        position: "top-center",
      });
      console.log("Showing toast:", nextNotification.message);
    } else {
      toast(nextNotification.message, {
        duration: 5000,
        position: "top-center",
        style: {
          background: "#f39c12",
          color: "#fff",
        },
      });
      // console.log("Showing toast:", nextNotification.message);
    }

    // Mark notification as shown and process next one immediately
    setTimeout(() => {
      this.setState({ isShowingNotification: false }, () => {
        // Process next notification if available
        if (remainingQueue.length > 0) {
          this.processNotificationQueue();
        }
      });
    }, 5000); // Wait for current notification to finish
  };

  // Reset TAT notifications (call this when needed, e.g., daily reset)
  resetTatNotifications = () => {
    this.setState({
      tatNotifications: new Set(),
      lastTatCheck: null,
      isShowingNotification: false,
      notificationQueue: [],
    });
  };

  // Clear specific patient notification (call this when patient status changes)
  clearPatientTatNotification = (patientId) => {
    const { tatNotifications, notificationQueue } = this.state;
    const newNotifications = new Set(tatNotifications);

    // Remove all notifications for this patient from tracking set
    for (let notification of newNotifications) {
      if (notification.startsWith(patientId + "_")) {
        newNotifications.delete(notification);
      }
    }

    // Remove all notifications for this patient from queue
    const filteredQueue = notificationQueue.filter(
      (notification) => notification.patientId !== patientId
    );

    this.setState({
      tatNotifications: newNotifications,
      notificationQueue: filteredQueue,
    });
  };

  // Start tracking progress for a patient
  startPatientProgressTracking = (patientId) => {
    const { patientProgress } = this.state;

    // Set the patient as active for progress tracking
    const updatedProgress = {
      ...patientProgress,
      [patientId]: {
        progress: 0,
        isActive: true,
      },
    };
    this.setState({ patientProgress: updatedProgress });

    // Start polling progress
    const progressInterval = setInterval(async () => {
      try {
        const response = await axios.get(
          `${apiUrl}api/common/getProgressStatus/${patientId}`
        );
        const progress = parseInt(response.data.progress) || 0;

        const currentProgress = { ...this.state.patientProgress };
        currentProgress[patientId] = {
          progress: progress,
          isActive: progress < 100 && progress > 0, // Only show if between 1-99%
        };
        this.setState({ patientProgress: currentProgress });

        // Stop polling when progress reaches 100
        if (progress >= 100) {
          clearInterval(progressInterval);
          setTimeout(() => {
            const finalProgress = { ...this.state.patientProgress };
            finalProgress[patientId] = {
              progress: 0,
              isActive: false,
            };
            this.setState({ patientProgress: finalProgress });
          }, 1500);
        }
      } catch (error) {
        console.error("Error fetching progress:", error);
      }
    }, 1000); // Poll every second
  };

  render() {
    if (localStorage.jwtToken == undefined) {
      window.location.href = "/";
    }
    const filteredRows = this.filterRows();
    const { errors, doctors, selectedDoctor, dob } = this.state;
    const options = doctors.map((doctor) => ({
      value: doctor._id,
      label: doctor.name,
    }));

    // Customer dropdown (edit modal): options from the loaded customer list.
    const customerOptions = (this.state.customerList || []).map((c) => ({
      value: c.id,
      label: c.name,
    }));
    // Resolve the currently selected customer — by id first, then by name.
    // If the patient's current customer isn't in the list (e.g. one this admin
    // can't see), still show it as the selected value instead of blanking it.
    let selectedCustomer = null;
    if (this.state.customerId) {
      selectedCustomer =
        customerOptions.find((o) => String(o.value) === String(this.state.customerId)) || null;
    }
    if (!selectedCustomer && this.state.customer_details) {
      selectedCustomer =
        customerOptions.find(
          (o) => o.label && o.label.toUpperCase() === String(this.state.customer_details).toUpperCase()
        ) || { value: "", label: this.state.customer_details };
    }

    /* const { errors,doctors } = this.state;*/

    // Map filtered doctors to options
    // const doctorsList =
    //   filteredDoctors.length > 0
    //     ? filteredDoctors.map((item, i) => (
    //         <option
    //           key={i}
    //           value={item._id}
    //           selected={doctor_name === item.name}
    //         >
    //           {item.name}
    //         </option>
    //       ))
    //     : null;
    return (
      <div className="wrapper theme-6-active box-layout pimary-color-green">
        {/* TopNav removed — profile & logout moved to SideBar */}
        <Toaster position="top-center" reverseOrder={false} />

        {/* Type-10 "new patient assigned" popup — lists what the admin just
            assigned and which server it's on, since the verifier may be
            logged into a different server right now. Same component backs
            both Patient List and the Queue view (?queue=1). */}
        <div
          id="newAssignmentModal"
          className="modal fade"
          role="dialog"
          data-backdrop="static"
          data-keyboard="false"
        >
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h4 className="modal-title text-center">
                  New Patient{this.state.newAssignmentAlerts.length === 1 ? "" : "s"} Assigned
                </h4>
              </div>
              <div className="modal-body">
                <ul style={{ listStyle: "none", padding: 0, margin: 0 }}>
                  {this.state.newAssignmentAlerts.map((a) => (
                    <li
                      key={a.id}
                      style={{
                        padding: "10px 12px",
                        marginBottom: 8,
                        border: "1px solid #eee",
                        borderRadius: 6,
                      }}
                    >
                      <div style={{ fontWeight: 600 }}>
                        {a.patientName}
                        {a.deviceId != null ? ` (Device ${a.deviceId})` : ""}
                      </div>
                      <div style={{ color: "#777", fontSize: 13 }}>
                        Server: {a.server || "—"}
                      </div>
                    </li>
                  ))}
                </ul>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={this.acknowledgeNewAssignments}
                >
                  Got it
                </button>
              </div>
            </div>
          </div>
        </div>

        <AddModalReport
          userid={this.state.generatereportuserid}
          onSelectModalReport={this.resetModalReport.bind(this)}
          isOpen={this.state.isModalReportOpen}
          treemenu={this.state.treemenu}
        />
        <AddModalComplete
          userid={this.state.userid}
          isOpen={this.state.isModalCompleteOpen}
          onResetModal={this.resetModalComplete}
          patientName={this.state.patientName}
        />
        {/* Priority popup - centered modal */}
        {this.state.modalPatientId && (
          <div
            style={{
              position: "fixed",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              zIndex: 1000,
              backgroundColor: "white",
              border: "1px solid #ccc",
              borderRadius: "4px",
              boxShadow: "0 2px 8px rgba(248, 242, 242, 0.15)",
              padding: "12px",
              minWidth: "280px",
              maxWidth: "350px",
            }}
          >
            <div style={{ marginBottom: "10px", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
              <h5 style={{ margin: 0, fontSize: "14px", fontWeight: "bold" }}>Priority</h5>
              <button
                onClick={this.closePriorityModal}
                style={{
                  background: "none",
                  color: "#1a1919",
                  border: "none",
                  fontSize: "18px",
                  
                  padding: 0,
                }}
              >
                ×
              </button>
            </div>

            <div style={{ marginBottom: "10px" }}>
              <label style={{ fontSize: "12px", marginBottom: "6px", display: "block", fontWeight: 600 }}>Priority Status</label>
              <div style={{ display: "flex", gap: "6px" }}>
                {[
                  { v: "1", label: "High",     color: "#e74c3c", bg: "rgba(231,76,60,0.15)"   },
                  { v: "2", label: "Moderate",  color: "#f39c12", bg: "rgba(243,156,18,0.15)"  },
                  { v: "3", label: "Simple",    color: "#3498db", bg: "rgba(52,152,219,0.15)"  },
                  { v: "4", label: "None",      color: "#8095a3", bg: "rgba(128,149,163,0.15)" },
                ].map((p) => {
                  const isActive = String(this.state.modalPriority || "") === p.v;
                  return (
                    <button
                      key={p.v}
                      type="button"
                      onClick={() => this.setState({ modalPriority: p.v })}
                      style={{
                        flex: 1,
                        padding: "7px 4px",
                        fontSize: "12px",
                        fontWeight: 700,
                        borderRadius: "8px",
                        border: `1px solid ${isActive ? p.color : "rgba(255,255,255,0.1)"}`,
                        background: isActive ? p.bg : "rgba(255,255,255,0.05)",
                        color: isActive ? p.color : "#666",
                        cursor: "pointer",
                        transition: "all 0.15s",
                        letterSpacing: "0.2px",
                      }}
                    >
                      {p.label}
                    </button>
                  );
                })}
              </div>
            </div>

            <div style={{ marginBottom: "8px" }}>
              <label style={{ fontSize: "12px", marginBottom: "4px", display: "block" }}>Date & Time</label>
              <input
                type="datetime-local"
                step="1" 
                className="form-control priority-datetime"
                style={{
                  fontSize: "13px",
                  padding: "10px 12px",
                  backgroundColor: "white",
                  color: "black",
                  cursor: "pointer",
                  border: "1px solid #ced4da",
                  borderRadius: "4px",
                  width: "100%",
                  boxSizing: "border-box",
                }}
                value={this.state.modalDateTime || ""}
                onChange={(e) => this.setState({ modalDateTime: e.target.value })}
              />
            </div>

            <div style={{ display: "flex", gap: "8px", justifyContent: "flex-end" }}>
              <button
                type="button"
                className="btn btn-sm btn-primary"
                onClick={this.savePriorityChange}
                style={{ fontSize: "12px", padding: "6px 12px" }}
              >
                Save
              </button>
              <button
                type="button"
                className="btn btn-sm btn-default"
                onClick={this.closePriorityModal}
                style={{ fontSize: "12px", padding: "6px 12px" }}
              >
                Cancel
              </button>
            </div>
          </div>
        )}
        <SideBar menus={this.state.menus} profileLink={this.state.profileLink} />

        <div className="right-sidebar-backdrop"></div>
        <div className="page-wrapper" style={{ marginTop: "6px", background: "#041415", minHeight: "100vh" }}>
          <div className="container-fluid" style={{ padding: "8px 4px" }}>
            <div id="myModalDHome" className="modal fade" role="dialog">
              <div className="modal-dialog">
                <div className="modal-content">
                  <div className="modal-header">
                    <button
                      type="button"
                      className="close"
                      data-dismiss="modal"
                    >
                      &times;
                    </button>
                    <h4 className="modal-title text-center">
                      General Settings
                    </h4>
                  </div>
                  <form method="post" onSubmit={this.onSubmit}>
                    <div className="modal-body">
                      <div className="row row-sm-offset">
                        <br />
                        <div className="col-md-4 multi-horizontal">
                          <div className="form-group">
                            <label
                              className="form-control-label mbr-fonts-style display-7"
                              style={{ color: "Black" }}
                            >
                              Normal Heart Rate Min
                            </label>
                            <input
                              type="text"
                              className={classnames("form-control", {
                                errors: errors.nor_minhr,
                              })}
                              name="nor_minhr"
                              required=""
                              id="nor_minhr"
                              onChange={this.onChange}
                              value={this.state.nor_minhr}
                            />
                          </div>
                        </div>
                        <div className="col-md-4 multi-horizontal">
                          <div className="form-group">
                            <label
                              className="form-control-label mbr-fonts-style display-7"
                              style={{ color: "Black" }}
                            >
                              Normal Heart Rate Max
                            </label>
                            <input
                              type="text"
                              className={classnames("form-control", {
                                errors: errors.nor_maxhr,
                              })}
                              name="nor_maxhr"
                              required=""
                              id="nor_maxhr"
                              onChange={this.onChange}
                              value={this.state.nor_maxhr}
                            />
                          </div>
                        </div>
                        <div className="col-md-4 multi-horizontal">
                          <div className="form-group">
                            <label
                              className="form-control-label mbr-fonts-style display-7"
                              style={{ color: "Black" }}
                            >
                              QTC Formula
                            </label>
                            <select
                              name="qtcformula"
                              className={classnames("form-control", {
                                errors: errors.qtcformula,
                              })}
                              value={this.state.qtcformula}
                              onChange={this.onChange}
                            >
                              <option value="Bazett">Bazett </option>
                              <option value="Fridericia">Fridericia</option>
                              <option value="Framingham">Framingham</option>
                              <option value="Hodges">Hodges</option>
                            </select>
                          </div>
                        </div>
                      </div>
                      <div className="row row-sm-offset">
                        <br />
                        <div className="col-md-4 multi-horizontal">
                          <div className="form-group">
                            <label
                              className="form-control-label mbr-fonts-style display-7"
                              style={{ color: "Black" }}
                            >
                              QTC Value Min
                            </label>
                            <input
                              type="text"
                              className={classnames("form-control", {
                                errors: errors.qtcvalue_min,
                              })}
                              name="qtcvalue_min"
                              required=""
                              id="qtcvalue_min"
                              onChange={this.onChange}
                              value={this.state.qtcvalue_min}
                            />
                          </div>
                        </div>
                        <div className="col-md-4 multi-horizontal">
                          <div className="form-group">
                            <label
                              className="form-control-label mbr-fonts-style display-7"
                              style={{ color: "Black" }}
                            >
                              QTC Value Max
                            </label>
                            <input
                              type="text"
                              className={classnames("form-control", {
                                errors: errors.qtcvaluemax,
                              })}
                              name="qtcvaluemax"
                              required=""
                              id="qtcvaluemax"
                              onChange={this.onChange}
                              value={this.state.qtcvaluemax}
                            />
                          </div>
                        </div>
                        <div className="col-md-4 multi-horizontal">
                          <div className="form-group">
                            <label
                              className="form-control-label mbr-fonts-style display-7"
                              style={{ color: "Black" }}
                            >
                              QRS Width Min(ms){" "}
                            </label>
                            <input
                              type="text"
                              className={classnames("form-control", {
                                errors: errors.qrswidth_min,
                              })}
                              name="qrswidth_min"
                              required=""
                              id="qrswidth_min"
                              onChange={this.onChange}
                              value={this.state.qrswidth_min}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="row row-sm-offset">
                        <div className="col-md-4 multi-horizontal">
                          <div className="form-group">
                            <label
                              className="form-control-label mbr-fonts-style display-7"
                              style={{ color: "Black" }}
                            >
                              QRS Width Max (ms){" "}
                            </label>
                            <input
                              type="text"
                              className={classnames("form-control", {
                                errors: errors.qrswidth_max,
                              })}
                              name="qrswidth_max"
                              required=""
                              id="qrswidth_max"
                              onChange={this.onChange}
                              value={this.state.qrswidth_max}
                            />
                          </div>
                        </div>
                        <div className="col-md-4 multi-horizontal">
                          <div className="form-group">
                            <label
                              className="form-control-label mbr-fonts-style display-7"
                              style={{ color: "Black" }}
                            >
                              QRS Amplitude Min (mv)
                            </label>
                            <input
                              type="text"
                              className={classnames("form-control", {
                                errors: errors.qrsamp_min,
                              })}
                              name="qrsamp_min"
                              required=""
                              id="qrsamp_min"
                              onChange={this.onChange}
                              value={this.state.qrsamp_min}
                            />
                          </div>
                        </div>
                        <div className="col-md-4 multi-horizontal">
                          <div className="form-group">
                            <label
                              className="form-control-label mbr-fonts-style display-7"
                              style={{ color: "Black" }}
                            >
                              QRS Amplitude Max (mv)
                            </label>
                            <input
                              type="text"
                              className={classnames("form-control", {
                                errors: errors.qrsamp_max,
                              })}
                              name="qrsamp_max"
                              required=""
                              id="qrsamp_max"
                              onChange={this.onChange}
                              value={this.state.qrsamp_max}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="row row-sm-offset">
                        <div className="col-md-4 multi-horizontal">
                          <div className="form-group">
                            <label
                              className="form-control-label mbr-fonts-style display-7"
                              style={{ color: "Black" }}
                            >
                              ST Elevation (mm)
                            </label>
                            <input
                              type="text"
                              className={classnames("form-control", {
                                errors: errors.stelevation,
                              })}
                              name="stelevation"
                              required=""
                              id="stelevation"
                              onChange={this.onChange}
                              value={this.state.stelevation}
                            />
                          </div>
                        </div>
                        <div className="col-md-4 multi-horizontal">
                          <div className="form-group">
                            <label
                              className="form-control-label mbr-fonts-style display-7"
                              style={{ color: "Black" }}
                            >
                              P Width Min (ms)
                            </label>
                            <input
                              type="text"
                              className={classnames("form-control", {
                                errors: errors.pwidth_min,
                              })}
                              name="pwidth_min"
                              required=""
                              id="pwidth_min"
                              onChange={this.onChange}
                              value={this.state.pwidth_min}
                            />
                          </div>
                        </div>
                        <div className="col-md-4 multi-horizontal">
                          <div className="form-group">
                            <label
                              className="form-control-label mbr-fonts-style display-7"
                              style={{ color: "Black" }}
                            >
                              P Width Max (ms)
                            </label>
                            <input
                              type="text"
                              className={classnames("form-control", {
                                errors: errors.pwidth_max,
                              })}
                              name="pwidth_max"
                              required=""
                              id="pwidth_max"
                              onChange={this.onChange}
                              value={this.state.pwidth_max}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="row row-sm-offset">
                        <div className="col-md-4 multi-horizontal">
                          <div className="form-group">
                            <label
                              className="form-control-label mbr-fonts-style display-7"
                              style={{ color: "Black" }}
                            >
                              P Amplitude Min (mv)
                            </label>
                            <input
                              type="text"
                              className={classnames("form-control", {
                                errors: errors.pamp_min,
                              })}
                              name="pamp_min"
                              required=""
                              id="pamp_min"
                              onChange={this.onChange}
                              value={this.state.pamp_min}
                            />
                          </div>
                        </div>
                        <div className="col-md-4 multi-horizontal">
                          <div className="form-group">
                            <label
                              className="form-control-label mbr-fonts-style display-7"
                              style={{ color: "Black" }}
                            >
                              P Amplitude Max (mv)
                            </label>
                            <input
                              type="text"
                              className={classnames("form-control", {
                                errors: errors.pamp_max,
                              })}
                              name="pamp_max"
                              required=""
                              id="pamp_max"
                              onChange={this.onChange}
                              value={this.state.pamp_max}
                            />
                          </div>
                        </div>
                        <div className="col-md-4 multi-horizontal">
                          <div className="form-group">
                            <label
                              className="form-control-label mbr-fonts-style display-7"
                              style={{ color: "Black" }}
                            >
                              T Width Min (ms){" "}
                            </label>
                            <input
                              type="text"
                              className={classnames("form-control", {
                                errors: errors.twidth_min,
                              })}
                              name="twidth_min"
                              required=""
                              id="twidth_min"
                              onChange={this.onChange}
                              value={this.state.twidth_min}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="row row-sm-offset">
                        <div className="col-md-4 multi-horizontal">
                          <div className="form-group">
                            <label
                              className="form-control-label mbr-fonts-style display-7"
                              style={{ color: "Black" }}
                            >
                              T Width Max (ms)
                            </label>
                            <input
                              type="text"
                              className={classnames("form-control", {
                                errors: errors.twidth_max,
                              })}
                              name="twidth_max"
                              required=""
                              id="twidth_max"
                              onChange={this.onChange}
                              value={this.state.twidth_max}
                            />
                          </div>
                        </div>
                        <div className="col-md-4 multi-horizontal">
                          <div className="form-group">
                            <label
                              className="form-control-label mbr-fonts-style display-7"
                              style={{ color: "Black" }}
                            >
                              T Amplitude Min (mv)
                            </label>
                            <input
                              type="text"
                              className={classnames("form-control", {
                                errors: errors.tamp_min,
                              })}
                              name="tamp_min"
                              required=""
                              id="tamp_min"
                              onChange={this.onChange}
                              value={this.state.tamp_min}
                            />
                          </div>
                        </div>
                        <div className="col-md-4 multi-horizontal">
                          <div className="form-group">
                            <label
                              className="form-control-label mbr-fonts-style display-7"
                              style={{ color: "Black" }}
                            >
                              T Amplitude Max (mv)
                            </label>
                            <input
                              type="text"
                              className={classnames("form-control", {
                                errors: errors.tamp_max,
                              })}
                              name="tamp_max"
                              required=""
                              id="tamp_max"
                              onChange={this.onChange}
                              value={this.state.tamp_max}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="row row-sm-offset">
                        <div className="col-md-4 multi-horizontal">
                          <div className="form-group">
                            <label
                              className="form-control-label mbr-fonts-style display-7"
                              style={{ color: "Black" }}
                            >
                              PR Interval Min{" "}
                            </label>
                            <input
                              type="text"
                              className={classnames("form-control", {
                                errors: errors.printerval_min,
                              })}
                              name="printerval_min"
                              required=""
                              id="printerval_min"
                              onChange={this.onChange}
                              value={this.state.printerval_min}
                            />
                          </div>
                        </div>
                        <div className="col-md-4 multi-horizontal">
                          <div className="form-group">
                            <label
                              className="form-control-label mbr-fonts-style display-7"
                              style={{ color: "Black" }}
                            >
                              PR Interval Max{" "}
                            </label>
                            <input
                              type="text"
                              className={classnames("form-control", {
                                errors: errors.printerval_max,
                              })}
                              name="printerval_max"
                              required=""
                              id="printerval_max"
                              onChange={this.onChange}
                              value={this.state.printerval_max}
                            />
                          </div>
                        </div>
                        <div className="col-md-4 multi-horizontal">
                          <div className="form-group">
                            <label
                              className="form-control-label mbr-fonts-style display-7"
                              style={{ color: "Black" }}
                            >
                              Tachy Lower Limit{" "}
                            </label>
                            <input
                              type="text"
                              className={classnames("form-control", {
                                errors: errors.tachyhr_lower,
                              })}
                              name="tachyhr_lower"
                              required=""
                              id="tachyhr_lower"
                              onChange={this.onChange}
                              value={this.state.tachyhr_lower}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="row row-sm-offset">
                        <div className="col-md-4 multi-horizontal">
                          <div className="form-group">
                            <label
                              className="form-control-label mbr-fonts-style display-7"
                              style={{ color: "Black" }}
                            >
                              Tachy Upper Limit{" "}
                            </label>
                            <input
                              type="text"
                              className={classnames("form-control", {
                                errors: errors.tachyhr_upper,
                              })}
                              name="tachyhr_upper"
                              required=""
                              id="tachyhr_upper"
                              onChange={this.onChange}
                              value={this.state.tachyhr_upper}
                            />
                          </div>
                        </div>
                        <div className="col-md-4 multi-horizontal">
                          <div className="form-group">
                            <label
                              className="form-control-label mbr-fonts-style display-7"
                              style={{ color: "Black" }}
                            >
                              Brady Lower Limit{" "}
                            </label>
                            <input
                              type="text"
                              className={classnames("form-control", {
                                errors: errors.bradyhr_lower,
                              })}
                              name="bradyhr_lower"
                              required=""
                              id="bradyhr_lower"
                              onChange={this.onChange}
                              value={this.state.bradyhr_lower}
                            />
                          </div>
                        </div>
                        <div className="col-md-4 multi-horizontal">
                          <div className="form-group">
                            <label
                              className="form-control-label mbr-fonts-style display-7"
                              style={{ color: "Black" }}
                            >
                              Brady Upper Limit{" "}
                            </label>
                            <input
                              type="text"
                              className={classnames("form-control", {
                                errors: errors.bradyhr_upper,
                              })}
                              name="bradyhr_upper"
                              required=""
                              id="bradyhr_upper"
                              onChange={this.onChange}
                              value={this.state.bradyhr_upper}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="row row-sm-offset">
                        <div className="col-md-4 multi-horizontal">
                          <div className="form-group">
                            <label
                              className="form-control-label mbr-fonts-style display-7"
                              style={{ color: "Black" }}
                            >
                              ST Depression (mm)
                            </label>
                            <input
                              type="text"
                              className={classnames("form-control", {
                                errors: errors.stdepression,
                              })}
                              name="stdepression"
                              required=""
                              id="stdepression"
                              onChange={this.onChange}
                              value={this.state.stdepression}
                            />
                          </div>
                        </div>
                        <div className="col-md-4 multi-horizontal">
                          <div className="form-group">
                            <label
                              className="form-control-label mbr-fonts-style display-7"
                              style={{ color: "Black" }}
                            >
                              Pause Length (s){" "}
                            </label>
                            <input
                              type="text"
                              className={classnames("form-control", {
                                errors: errors.pauselength,
                              })}
                              name="pauselength"
                              required=""
                              id="pauselength"
                              onChange={this.onChange}
                              value={this.state.pauselength}
                            />
                          </div>
                        </div>
                        <div className="col-md-4 multi-horizontal">
                          <div className="form-group">
                            <label
                              className="form-control-label mbr-fonts-style display-7"
                              style={{ color: "Black" }}
                            >
                              Graphs To Be Generated(no:){" "}
                            </label>
                            <input
                              type="text"
                              className={classnames("form-control", {
                                errors: errors.graph_gen,
                              })}
                              name="graph_gen"
                              required=""
                              id="graph_gen"
                              onChange={this.onChange}
                              value={this.state.graph_gen}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="modal-footer">
                      <button
                        type="submit"
                        className="btn btn-success"
                        style={{ color: "Black" }}
                        disabled={this.state.loadingEditModal} // Disable while loading
                      >
                        Submit
                      </button>
                      {
                        <button
                          id="closePopup"
                          type="button"
                          className="btn btn-default closePopup"
                          data-dismiss="modal"
                          style={{ color: "Black" }}
                        >
                          Close
                        </button>
                      }
                    </div>
                  </form>
                </div>
              </div>
            </div>
            {/* ── Comments Modal ── */}
            <div id="commentinfomodal" className="modal fade" role="dialog" aria-hidden="true">
              <div className="modal-dialog" style={{ maxWidth: 860, margin: "20px auto", width: "94%" }}>
                <div className="modal-content" style={{ borderRadius: 10, overflow: "hidden", border: "none", boxShadow: "0 12px 40px rgba(0,0,0,0.4)" }}>

                  {/* ── Header ── */}
                  <div style={{ background: "#1e2d38", padding: "12px 18px", display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                    <div>
                      <div style={{ color: "#fff", fontWeight: 700, fontSize: "15px", display: "flex", alignItems: "center", gap: 6 }}>
                        💬 Comments{(this.state.comments || "").trim() ? ` (${(this.state.comments || "").trim().split("\n").filter(l => l.trim()).length})` : ""}
                      </div>
                      {this.state.patient_name && (
                        <div style={{ color: "#89c4e1", fontSize: "12px", marginTop: 2 }}>
                          {this.state.patient_name}
                          {this.state.userid && <span style={{ color: "#5a8fa8", marginLeft: 6, fontSize: "11px" }}>#{this.state.patientId || ""}</span>}
                        </div>
                      )}
                    </div>
                    <button type="button" data-dismiss="modal" className="closePopup"
                      style={{ background: "rgba(255,255,255,0.1)", border: "none", color: "#fff", width: 28, height: 28, borderRadius: "50%", fontSize: "16px", lineHeight: 1, cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center" }}>
                      ×
                    </button>
                  </div>

                  {/* ── Comment History ── */}
                  {(() => {
                    const raw = (this.state.comments || "").trim();
                    const lines = (raw ? raw.split("\n").filter((l) => l.trim()) : []).reverse(); // newest first
                    return (
                      <div style={{ background: "#f5f7fa", borderBottom: "1px solid #e2e8f0", maxHeight: "calc(100vh - 360px)", minHeight: 120, overflowY: "auto", padding: lines.length ? "12px 16px" : "0" }}>
                        {lines.length === 0 ? (
                          <div style={{ padding: "18px 16px", textAlign: "center", color: "#aaa", fontSize: "13px" }}>No comments yet</div>
                        ) : (
                          lines.map((line, idx) => {
                            // Parse "text — Name [timestamp]" or "text -BY Name"
                            const byMatch = line.match(/^(.*?)\s*[—–-]+\s*BY\s+(.+?)(?:\s*\[(.+?)\])?$/i)
                                         || line.match(/^(.*?)\s*—\s*(.+?)(?:\s*\[(.+?)\])?$/);
                            const text   = byMatch ? byMatch[1].trim() : line;
                            const author = byMatch ? byMatch[2].trim() : "";
                            const time   = byMatch ? byMatch[3] || "" : "";
                            const initials = author ? author.split(" ").map(w => w[0]).join("").slice(0,2).toUpperCase() : "?";
                            const colors = ["#3498db","#9b59b6","#1abc9c","#e67e22","#e74c3c","#2ecc71"];
                            const avatarColor = colors[initials.charCodeAt(0) % colors.length];
                            return (
                              <div key={idx} style={{ display: "flex", gap: 10, marginBottom: idx < lines.length - 1 ? 12 : 0 }}>
                                {/* Avatar */}
                                <div style={{ width: 32, height: 32, borderRadius: "50%", background: avatarColor, color: "#fff", display: "flex", alignItems: "center", justifyContent: "center", fontSize: "11px", fontWeight: 700, flexShrink: 0, marginTop: 2 }}>
                                  {initials}
                                </div>
                                {/* Bubble */}
                                <div style={{ flex: 1 }}>
                                  <div style={{ background: "#fff", border: "1px solid #e2e8f0", borderRadius: "0 8px 8px 8px", padding: "8px 12px", fontSize: "13px", color: "#2d3748", lineHeight: 1.5, whiteSpace: "pre-line", boxShadow: "0 1px 3px rgba(0,0,0,0.06)" }}>
                                    {text.replace(/^\[[A-Za-z]+\][^|]*\|\s*/, "")}
                                  </div>
                                  <div style={{ fontSize: "11px", color: "#94a3b8", marginTop: 3, paddingLeft: 2 }}>
                                    <span style={{ fontWeight: 600, color: "#64748b" }}>{author || (/^\[[A-Za-z]+\][^|]*\|/.test(text) ? "System · " + text.split("|")[0].replace(/[\[\]]/g, "").trim() : "Unknown")}</span>
                                    {time && <span style={{ marginLeft: 6 }}>{time}</span>}
                                  </div>
                                </div>
                              </div>
                            );
                          })
                        )}
                      </div>
                    );
                  })()}

                  {/* ── New Comment Input ── */}
                  <div style={{ background: "#fff", padding: "14px 16px 10px" }}>
                    <div style={{ fontSize: "11px", fontWeight: 600, color: "#64748b", textTransform: "uppercase", letterSpacing: "0.5px", marginBottom: 8 }}>Add New Comment</div>
                    <textarea
                      value={this.state.newComment || ""}
                      onChange={(e) => this.setState({ newComment: e.target.value })}
                      placeholder="Type your observation, finding or note here…"
                      maxLength={300}
                      rows={3}
                      style={{ width: "100%", fontSize: "13px", color: "#2d3748", border: "1px solid #cbd5e0", borderRadius: 6, padding: "10px 12px", resize: "none", outline: "none", fontFamily: "inherit", lineHeight: 1.6, transition: "border-color 0.2s" }}
                      onFocus={e => e.target.style.borderColor = "#4299e1"}
                      onBlur={e => e.target.style.borderColor = "#cbd5e0"}
                    />
                    <div style={{ textAlign: "right", fontSize: "11px", color: (this.state.newComment || "").length > 250 ? "#e74c3c" : "#94a3b8", marginTop: 3 }}>
                      {(this.state.newComment || "").length}/300
                    </div>
                  </div>

                  {/* ── Footer ── */}
                  <div style={{ padding: "8px 16px 14px", background: "#fff", display: "flex", justifyContent: "flex-end", gap: 8, borderTop: "1px solid #f0f0f0" }}>
                    <button type="button" data-dismiss="modal" className="closePopup"
                      style={{ padding: "7px 20px", fontSize: "13px", background: "#f8fafc", border: "1px solid #e2e8f0", borderRadius: 6, color: "#555", cursor: "pointer", fontWeight: 500 }}>
                      Cancel
                    </button>
                    <button id={this.state.userid} type="button" onClick={this.submitComment}
                      disabled={!(this.state.newComment || "").trim()}
                      style={{ padding: "7px 22px", fontSize: "13px", background: (this.state.newComment || "").trim() ? "#1e8449" : "#a8d5b5", border: "none", borderRadius: 6, color: "#fff", fontWeight: 700, cursor: (this.state.newComment || "").trim() ? "pointer" : "not-allowed", transition: "background 0.2s" }}>
                      ✓ Add Comment
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <div
              id="showblockreport"
              className="modal fade"
              role="dialog"
              aria-labelledby="showblockreportLabel"
              aria-hidden="true"
            >
              <div className="modal-dialog">
                <div className="modal-content">
                  <div className="modal-header">
                    <button
                      type="button"
                      className="close"
                      data-dismiss="modal"
                      aria-label="Close"
                    >
                      <span aria-hidden="true">&times;</span>
                    </button>
                    <h4 className="modal-title text-center">Block Report</h4>
                  </div>
                  <div className="modal-body">
                    <div className="form-group">
                      <label style={{ color: "black" }}>Block Report</label>
                      <select
                        className="form-control"
                        value={this.state.blockReportOption}
                        onChange={(e) =>
                          this.setState({ blockReportOption: e.target.value })
                        }
                      >
                        <option value="Yes">Yes</option>
                        <option value="No">No</option>
                      </select>
                    </div>
                  </div>
                  <div className="modal-footer">
                    <div className="row row-sm-offset">
                      <div className="col-md-6 multi-horizontal">
                        <button
                          id={this.state.userid}
                          data-dismiss="modal"
                          type="submit"
                          className="btn btn-success"
                          style={{ color: "Black" }}
                          onClick={async () => {
                            const data = await axios.post(
                              `${apiUrl}api/common/updateblockPatient`,
                              {
                                userid: this.state.userid,
                                block: this.state.blockReportOption,
                              }
                            );
                            console.log(data);
                            if (this.state.blockReportOption === "Yes") {
                              toast.success("Patient Report Blocked");
                            } else if (this.state.blockReportOption === "No") {
                              toast.success("Patient Report Unblocked");
                            }

                            this.setState({
                              blockReportOption: "",
                              showBlockReportModal: false,
                            });
                          }}
                        >
                          Submit
                        </button>
                      </div>
                      <div className="col-md-6 multi-horizontal text-left">
                        <button
                          type="button"
                          className="btn btn-default closePopup"
                          data-dismiss="modal"
                        >
                          Close
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {(this.state.verifiertype === "8" || this.state.verifiertype === "1" || this.state.verifiertype === "10") && (
              <div
                id="progressinfomodal"
                className="modal fade"
                role="dialog"
                aria-labelledby="commentModalLabel"
                aria-hidden="true"
              >
                <div className="modal-dialog">
                  <div
                    className="modal-content"
                    style={{
                      background: "#14171f",
                      border: "1px solid #242833",
                      color: "#e6e6e6",
                      borderRadius: 12,
                    }}
                  >
                    <div
                      className="modal-header"
                      style={{
                        background: "#0f1117",
                        borderBottom: "1px solid #242833",
                        padding: "12px 16px",
                        borderRadius: "12px 12px 0 0",
                      }}
                    >
                      <button
                        onClick={this.resetInfoModal.bind(this)}
                        type="button"
                        className="close"
                        data-dismiss="modal"
                        aria-label="Close"
                        style={{ color: "#8a93a0", opacity: 0.9, fontSize: 22, marginTop: 0 }}
                      >
                        <span aria-hidden="true">&times;</span>
                      </button>
                      <h4
                        className="modal-title text-center"
                        id="commentModalLabel"
                        style={{ color: "#fff", fontSize: 15, fontWeight: 600 }}
                      >
                        Verifier Progress
                      </h4>
                    </div>

                    <div
                      className="modal-body"
                      style={{ padding: "14px 16px", maxHeight: "60vh", overflowY: "auto" }}
                    >
                      {(() => {
                        // Show only verifiers who actually verified at least one
                        // file for this patient. selectedVerifiersEfficency is
                        // populated by getverifiedprogress; entries exist only
                        // when a verifier has files for the patient.
                        const eff = this.state.selectedVerifiersEfficency || [];
                        const sv = this.state.selectedVerifiers || [];
                        const active = eff
                          .map((e) => {
                            const v = sv.find((x) => x.value === e.label);
                            return v ? { ...e, name: v.label } : null;
                          })
                          .filter(Boolean);

                        // While the API chain is running and we don't yet
                        // have any verifier results to render, show a spinner
                        // instead of the "no activity" placeholder.
                        if (
                          this.state.loadingVerifierProgress &&
                          active.length === 0
                        ) {
                          return (
                            <div
                              style={{
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "center",
                                justifyContent: "center",
                                padding: "40px 16px",
                                color: "#8a93a0",
                                fontSize: 13,
                                gap: 14,
                              }}
                            >
                              <div
                                style={{
                                  width: 38,
                                  height: 38,
                                  border: "3px solid #242833",
                                  borderTop: "3px solid #3F8EFC",
                                  borderRadius: "50%",
                                  animation:
                                    "vp-spin 0.9s linear infinite",
                                }}
                              />
                              <div>Loading verifier progress…</div>
                              {/* Indeterminate progress bar */}
                              <div
                                style={{
                                  width: "70%",
                                  maxWidth: 260,
                                  height: 4,
                                  background: "#1f232c",
                                  borderRadius: 999,
                                  overflow: "hidden",
                                  position: "relative",
                                }}
                              >
                                <div
                                  style={{
                                    position: "absolute",
                                    left: 0,
                                    top: 0,
                                    height: "100%",
                                    width: "40%",
                                    background:
                                      "linear-gradient(90deg, #3F8EFC, #2ECD99)",
                                    borderRadius: 999,
                                    animation:
                                      "vp-slide 1.4s ease-in-out infinite",
                                  }}
                                />
                              </div>
                              <style>{`
                                @keyframes vp-spin{to{transform:rotate(360deg)}}
                                @keyframes vp-slide{
                                  0%{left:-40%}
                                  100%{left:100%}
                                }
                              `}</style>
                            </div>
                          );
                        }

                        if (active.length === 0) {
                          return (
                            <div
                              style={{
                                color: "#8a93a0",
                                textAlign: "center",
                                padding: "32px 16px",
                                fontSize: 13,
                              }}
                            >
                              No verification activity yet for this patient.
                            </div>
                          );
                        }

                        // Sort: most files done first
                        active.sort(
                          (a, b) =>
                            (Number(b.totalEfficientCount) || 0) -
                            (Number(a.totalEfficientCount) || 0)
                        );

                        const fmtTime = (iso) => {
                          if (!iso || isNaN(Date.parse(iso))) return "—";
                          const d = new Date(iso);
                          return `${d.toLocaleDateString("en-IN")} ${d.toLocaleTimeString(
                            "en-IN",
                            { hour: "2-digit", minute: "2-digit", hour12: true }
                          )}`;
                        };

                        const tierColor = (e) => {
                          if (e >= 81) return "#22c55e"; // green
                          if (e >= 71) return "#84cc16"; // lime
                          if (e >= 41) return "#eab308"; // amber
                          return "#ef4444"; // red
                        };

                        return active.map((v, idx) => {
                          const effPct = Number(v.value) || 0;
                          const color = tierColor(effPct);
                          const avgPerFile = Number(v.averageTimePerECG) || 0;
                          return (
                            <div
                              key={idx}
                              style={{
                                background: "#181c25",
                                border: "1px solid #242833",
                                borderRadius: 10,
                                padding: "12px 14px",
                                marginBottom: 10,
                              }}
                            >
                              {/* Header: name + efficiency pill */}
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "space-between",
                                  marginBottom: 8,
                                }}
                              >
                                <div
                                  style={{
                                    color: "#e6e6e6",
                                    fontSize: 14,
                                    fontWeight: 600,
                                  }}
                                >
                                  {v.name}
                                </div>
                                <div
                                  style={{
                                    color,
                                    background: `${color}1f`,
                                    border: `1px solid ${color}55`,
                                    borderRadius: 999,
                                    padding: "2px 10px",
                                    fontSize: 11,
                                    fontWeight: 700,
                                    fontVariantNumeric: "tabular-nums",
                                  }}
                                >
                                  {effPct.toFixed(0)}% efficient
                                </div>
                              </div>

                              {/* Stat strip */}
                              <div
                                style={{
                                  display: "grid",
                                  gridTemplateColumns: "repeat(3, 1fr)",
                                  gap: 10,
                                  marginBottom: 10,
                                }}
                              >
                                <div>
                                  <div style={{ fontSize: 10, color: "#8a93a0", textTransform: "uppercase", letterSpacing: 0.5 }}>
                                    Files done
                                  </div>
                                  <div style={{ color: "#e6e6e6", fontSize: 14, fontWeight: 600, fontVariantNumeric: "tabular-nums" }}>
                                    {v.totalEfficientCount || 0}
                                  </div>
                                </div>
                                <div>
                                  <div style={{ fontSize: 10, color: "#8a93a0", textTransform: "uppercase", letterSpacing: 0.5 }}>
                                    Avg / file
                                  </div>
                                  <div style={{ color: "#e6e6e6", fontSize: 14, fontWeight: 600, fontVariantNumeric: "tabular-nums" }}>
                                    {avgPerFile > 0 ? `${avgPerFile.toFixed(1)} min` : "—"}
                                  </div>
                                </div>
                                <div>
                                  <div style={{ fontSize: 10, color: "#8a93a0", textTransform: "uppercase", letterSpacing: 0.5 }}>
                                    Time spent
                                  </div>
                                  <div style={{ color: "#e6e6e6", fontSize: 14, fontWeight: 600, fontVariantNumeric: "tabular-nums" }}>
                                    {v.totalSpendHours || "—"}
                                  </div>
                                </div>
                              </div>

                              {/* Time range */}
                              <div style={{ fontSize: 11, color: "#6b7380", marginBottom: 8 }}>
                                {fmtTime(v.startTime)} — {fmtTime(v.endTime)}
                              </div>

                              {/* Efficiency bar */}
                              <div
                                style={{
                                  height: 6,
                                  background: "#1f232c",
                                  borderRadius: 999,
                                  overflow: "hidden",
                                }}
                              >
                                <div
                                  style={{
                                    width: `${Math.min(100, Math.max(0, effPct))}%`,
                                    height: "100%",
                                    background: color,
                                    borderRadius: 999,
                                    transition: "width 0.3s ease",
                                  }}
                                />
                              </div>
                            </div>
                          );
                        });
                      })()}
                    </div>

                  </div>
                </div>
              </div>
            )}

            <div
              id="editInfoModal"
              className="modal fade"
              role="dialog"
              data-backdrop="static"
              data-keyboard="false"
            >
              <div className="modal-dialog modal-lg">
                <div className="modal-content">
                  <div className="modal-header" style={{ background: "#24333e", padding: "10px 16px", borderRadius: "6px 6px 0 0" }}>
                    <button type="button" className="close" data-dismiss="modal" onClick={this.resetInfoModal.bind(this)} style={{ color: "#fff", opacity: 0.8, marginTop: 0 }}>
                      &times;
                    </button>
                    <h4 className="modal-title" style={{ color: "#fff", fontSize: "15px", fontWeight: 600 }}>
                      ✏️ Edit Patient
                      {this.state.patient_name ? <span style={{ fontWeight: 400, fontSize: "13px", marginLeft: 8, opacity: 0.75 }}>— {this.state.patient_name}</span> : ""}
                    </h4>
                  </div>

                  <form method="post" onSubmit={this.onSubmitInfo}>
                    <div className="modal-body" style={{ position: "relative", padding: "16px 20px", fontSize: "13px" }}>
                      {/* Loading overlay */}
                      {this.state.loadingEditModal && (
                        <div style={{ position: "absolute", top: 0, left: 0, width: "100%", height: "100%", background: "rgba(255,255,255,0.8)", zIndex: 10, display: "flex", alignItems: "center", justifyContent: "center" }}>
                          <div style={{ width: 40, height: 40, border: "5px solid #f3f3f3", borderTop: "5px solid #3498db", borderRadius: "50%", animation: "spin 0.8s linear infinite" }}></div>
                          <style>{`@keyframes spin{0%{transform:rotate(0deg)}100%{transform:rotate(360deg)}}`}</style>
                        </div>
                      )}

                      {/* ── SECTION: Patient Info ── */}
                      <div style={{ background: "#f8f9fa", borderRadius: "6px", padding: "10px 14px", marginBottom: "10px" }}>
                        <div style={{ fontSize: "11px", fontWeight: 700, color: "#666", textTransform: "uppercase", letterSpacing: "0.5px", marginBottom: "8px" }}>Patient Info</div>
                        <div className="row" style={{ marginBottom: 0 }}>
                          <div className="col-md-4" style={{ paddingRight: 6 }}>
                            <div className="form-group" style={{ marginBottom: 8 }}>
                              <label style={{ color: "#444", fontSize: "12px", marginBottom: 2 }}>Name</label>
                              <input type="text" className="form-control input-sm" name="patient_name" onChange={this.onChange} value={this.state.patient_name} style={{ height: 30, fontSize: "13px" }} />
                            </div>
                          </div>
                          <div className="col-md-4" style={{ paddingRight: 6 }}>
                            <div className="form-group" style={{ marginBottom: 8 }}>
                              <label style={{ color: "#444", fontSize: "12px", marginBottom: 2 }}>Email</label>
                              <input type="text" className="form-control input-sm" name="email_id" onChange={this.onChange} value={this.state.email_id} style={{ height: 30, fontSize: "13px" }} />
                            </div>
                          </div>
                          <div className="col-md-4">
                            <div className="form-group" style={{ marginBottom: 8 }}>
                              <label style={{ color: "#444", fontSize: "12px", marginBottom: 2 }}>Phone</label>
                              <input type="text" className="form-control input-sm" name="phone" onChange={this.onChange} value={this.state.phone} style={{ height: 30, fontSize: "13px" }} />
                            </div>
                          </div>
                        </div>
                        <div className="row" style={{ marginBottom: 0 }}>
                          <div className="col-md-4" style={{ paddingRight: 6 }}>
                            <div className="form-group" style={{ marginBottom: 8 }}>
                              <label style={{ color: "#444", fontSize: "12px", marginBottom: 2 }}>Hospital</label>
                              <input type="text" className="form-control input-sm" name="hospital" onChange={this.onChange} value={this.state.hospital} style={{ height: 30, fontSize: "13px" }} />
                            </div>
                          </div>
                          <div className="col-md-4" style={{ paddingRight: 6 }}>
                            <div className="form-group" style={{ marginBottom: 8 }}>
                              <label style={{ color: "#444", fontSize: "12px", marginBottom: 2 }}>Doctor</label>
                              <Select
                                options={options}
                                value={selectedDoctor}
                                onChange={this.handleDoctorChange}
                                placeholder="Search Doctor"
                                classNamePrefix="react-select"
                                styles={{
                                  control: (base) => ({ ...base, minHeight: 30, height: 30, fontSize: "13px", borderColor: errors.doctor_id ? "red" : base.borderColor }),
                                  valueContainer: (base) => ({ ...base, padding: "0 6px" }),
                                  indicatorsContainer: (base) => ({ ...base, height: 30 }),
                                }}
                              />
                            </div>
                          </div>
                          <div className="col-md-2" style={{ paddingRight: 6 }}>
                            <div className="form-group" style={{ marginBottom: 8 }}>
                              <label style={{ color: "#444", fontSize: "12px", marginBottom: 2 }}>IP/OP</label>
                              <input type="text" className="form-control input-sm" onChange={this.onIpOpChange} value={this.state.ipop} style={{ height: 30, fontSize: "13px" }} />
                            </div>
                          </div>
                          <div className="col-md-2">
                            <div className="form-group" style={{ marginBottom: 8 }}>
                              <label style={{ color: "#444", fontSize: "12px", marginBottom: 2 }}>Age</label>
                              <input type="number" min="0" className="form-control input-sm" placeholder="Age" value={this.state.age || ""} onChange={this.handleAgeChange} style={{ height: 30, fontSize: "13px" }} />
                            </div>
                          </div>
                        </div>
                        <div className="row" style={{ marginBottom: 0 }}>
                          {/* Customer — searchable dropdown from the customer list */}
                          <div className="col-md-6" style={{ paddingRight: 6 }}>
                            <div className="form-group" style={{ marginBottom: 8 }}>
                              <label style={{ color: "#444", fontSize: "12px", marginBottom: 2 }}>Customer</label>
                              <Select
                                options={customerOptions}
                                value={selectedCustomer}
                                onChange={this.onCustomerChange}
                                isClearable
                                placeholder={
                                  this.state.customerList && this.state.customerList.length
                                    ? "Select customer…"
                                    : "Loading customers…"
                                }
                                classNamePrefix="react-select"
                                menuPlacement="auto"
                                maxMenuHeight={160}
                                styles={{
                                  control: (base) => ({ ...base, minHeight: 30, height: 30, fontSize: "13px" }),
                                  valueContainer: (base) => ({ ...base, padding: "0 6px" }),
                                  indicatorsContainer: (base) => ({ ...base, height: 30 }),
                                  option: (provided, state) => ({ ...provided, backgroundColor: state.isSelected ? "#24333e" : state.isFocused ? "#e5e5e5" : null, color: state.isSelected ? "white" : "black", fontSize: "12px", padding: "4px 10px" }),
                                }}
                              />
                            </div>
                          </div>
                        </div>
                      </div>

                      {/* ── SECTION: Clinical Settings ── */}
                      <div style={{ background: "#f8f9fa", borderRadius: "6px", padding: "10px 14px", marginBottom: "10px" }}>
                        <div style={{ fontSize: "11px", fontWeight: 700, color: "#666", textTransform: "uppercase", letterSpacing: "0.5px", marginBottom: "8px" }}>Clinical Settings</div>

                        {/* Row: File Type + Priority + Report Status */}
                        <div className="row" style={{ marginBottom: 4 }}>
                          <div className="col-md-4" style={{ paddingRight: 6 }}>
                            <label style={{ color: "#444", fontSize: "12px", marginBottom: 4, display: "block" }}>File Type</label>
                            <div className="btn-group" style={{ width: "100%" }}>
                              {["easy","moderate","hard"].map(ft => (
                                <button key={ft} type="button"
                                  onClick={() => this.handleTypeChange({ target: { value: ft } })}
                                  style={{ flex: 1, padding: "4px 0", fontSize: "12px", border: "1px solid #ccc", background: this.state.filetype === ft ? "#24333e" : "#fff", color: this.state.filetype === ft ? "#fff" : "#333", cursor: "pointer", textTransform: "capitalize", borderRadius: ft === "easy" ? "4px 0 0 4px" : ft === "hard" ? "0 4px 4px 0" : "0" }}
                                >{ft.charAt(0).toUpperCase() + ft.slice(1)}</button>
                              ))}
                            </div>
                          </div>
                          <div className="col-md-4" style={{ paddingRight: 6 }}>
                            <label style={{ color: "#444", fontSize: "12px", marginBottom: 4, display: "block" }}>Priority</label>
                            <div style={{ display: "flex", gap: "4px", width: "100%" }}>
                              {[
                                { v: "1", label: "High",     color: "#e74c3c", bg: "rgba(231,76,60,0.12)"  },
                                { v: "2", label: "Moderate", color: "#f39c12", bg: "rgba(243,156,18,0.12)" },
                                { v: "3", label: "Simple",   color: "#3498db", bg: "rgba(52,152,219,0.12)" },
                                { v: "4", label: "Normal",   color: "#27ae60", bg: "rgba(39,174,96,0.12)"  },
                              ].map((p) => {
                                const active = String(this.state.priority) === p.v;
                                return (
                                  <button key={p.v} type="button"
                                    onClick={() => this.onPriorityChange({ target: { value: p.v } })}
                                    style={{ flex: 1, padding: "5px 2px", fontSize: "11px", fontWeight: 700, border: `1px solid ${active ? p.color : "#ccc"}`, background: active ? p.bg : "#fff", color: active ? p.color : "#777", cursor: "pointer", borderRadius: "4px", transition: "all 0.15s" }}
                                  >{p.label}</button>
                                );
                              })}
                            </div>
                          </div>
                          <div className="col-md-4">
                            <label style={{ color: "#444", fontSize: "12px", marginBottom: 4, display: "block" }}>Report Status</label>
                            <select className="form-control input-sm" value={this.state.reportstatus} onChange={this.onReportStatuschange} style={{ height: 30, fontSize: "12px", padding: "2px 6px" }}>
                              <option value="0">Not Analyzed</option>
                              <option value="2">Analyze Started</option>
                              <option value="6">Analyze Completed</option>
                              <option value="3">Verification Completed</option>
                              <option value="4">In Preparation</option>
                              <option value="5">Report Completed</option>
                            </select>
                          </div>
                        </div>

                        {/* Row: Indication + Duration + Confirmation */}
                        <div className="row" style={{ marginTop: 8 }}>
                          <div className="col-md-4" style={{ paddingRight: 6 }}>
                            <div className="form-group" style={{ marginBottom: 6 }}>
                              <label style={{ color: "#444", fontSize: "12px", marginBottom: 2 }}>Indication</label>
                              <input type="text" className="form-control input-sm" name="indication" onChange={this.onChange} value={this.state.indication} style={{ height: 30, fontSize: "13px" }} />
                            </div>
                          </div>
                          <div className="col-md-4" style={{ paddingRight: 6 }}>
                            <div className="form-group" style={{ marginBottom: 6 }}>
                              <label style={{ color: "#444", fontSize: "12px", marginBottom: 2 }}>Monitoring Duration (Days)</label>
                              <input type="text" className="form-control input-sm" onChange={this.onDurationChange} value={this.state.duration} style={{ height: 30, fontSize: "13px" }} />
                            </div>
                          </div>
                          <div className="col-md-4">
                            <label style={{ color: "#444", fontSize: "12px", marginBottom: 4, display: "block" }}>Confirmation</label>
                            <div className="btn-group" style={{ width: "100%" }}>
                              {[
                                { v: "Yes", color: "#27ae60" },
                                { v: "No",  color: "#e74c3c" },
                                { v: "Hold", color: "#f39c12" },
                                ...(livePatientsEnabled ? [{ v: "Live", color: "#8e44ad" }] : []),
                              ].map((item, i, arr) => (
                                <button key={item.v} type="button"
                                  onClick={() => {
                                    this.setState({ Confirmation: item.v, selectedConfirmation: item.v });
                                    axios.post(`${apiUrl}api/patients/updateConfirmation`, {
                                      userid: this.state.userid,
                                      Confirmation: item.v,
                                      // Source + identity of the actor.
                                      // ConfirmationSource: "staff" vs "whatsapp"
                                      // ConfirmedBy / ConfirmedById: who the
                                      // staff member is, for the dashboard
                                      // "Confirmed by" badge. Falls back to
                                      // "Unknown staff" if localStorage was
                                      // cleared mid-session.
                                      ConfirmationSource: "staff",
                                      ConfirmedBy:
                                        localStorage.getItem("verifiername") || "Unknown staff",
                                      ConfirmedById:
                                        localStorage.getItem("verifierid") || null,
                                    }).catch(err => console.error("Confirmation update error:", err));
                                  }}
                                  style={{ flex: 1, padding: "4px 0", fontSize: "12px", fontWeight: 600, border: "1px solid #ccc", background: this.state.Confirmation === item.v ? item.color : "#fff", color: this.state.Confirmation === item.v ? "#fff" : "#555", cursor: "pointer", borderRadius: i === 0 ? "4px 0 0 4px" : i === arr.length - 1 ? "0 4px 4px 0" : "0" }}
                                >{item.v}</button>
                              ))}
                            </div>
                          </div>
                        </div>

                        {/* Row: Toggle buttons — Gender, AF, Cardiac, Pacemaker, Prioritize */}
                        <div className="row" style={{ marginTop: 8 }}>
                          {/* Gender */}
                          <div className="col-md-2" style={{ paddingRight: 6 }}>
                            <label style={{ color: "#444", fontSize: "12px", marginBottom: 4, display: "block" }}>Gender</label>
                            <div className="btn-group" style={{ width: "100%" }}>
                              {["M","F"].map(g => (
                                <button key={g} type="button"
                                  onClick={() => this.onGenderChange({ target: { value: g } })}
                                  style={{ flex: 1, padding: "4px 0", fontSize: "13px", fontWeight: 600, border: "1px solid #ccc", background: this.state.gender === g ? "#24333e" : "#fff", color: this.state.gender === g ? "#fff" : "#333", cursor: "pointer", borderRadius: g === "M" ? "4px 0 0 4px" : "0 4px 4px 0" }}
                                >{g}</button>
                              ))}
                            </div>
                          </div>
                          {/* Atrial Fibrillation */}
                          <div className="col-md-2" style={{ paddingRight: 6 }}>
                            <label style={{ color: "#444", fontSize: "12px", marginBottom: 4, display: "block" }}>Atrial Fib</label>
                            <div className="btn-group" style={{ width: "100%" }}>
                              {["yes","no"].map(v => (
                                <button key={v} type="button"
                                  onClick={() => this.setState({ af: v })}
                                  style={{ flex: 1, padding: "4px 0", fontSize: "12px", border: "1px solid #ccc", background: this.state.af === v ? (v === "yes" ? "#e74c3c" : "#27ae60") : "#fff", color: this.state.af === v ? "#fff" : "#333", cursor: "pointer", borderRadius: v === "yes" ? "4px 0 0 4px" : "0 4px 4px 0", textTransform: "capitalize" }}
                                >{v.charAt(0).toUpperCase() + v.slice(1)}</button>
                              ))}
                            </div>
                          </div>
                          {/* Cardiac Surgery */}
                          <div className="col-md-2" style={{ paddingRight: 6 }}>
                            <label style={{ color: "#444", fontSize: "12px", marginBottom: 4, display: "block" }}>Cardiac Surg.</label>
                            <div className="btn-group" style={{ width: "100%" }}>
                              {["yes","no"].map(v => (
                                <button key={v} type="button"
                                  onClick={() => this.setState({ cardiac_surgery: v })}
                                  style={{ flex: 1, padding: "4px 0", fontSize: "12px", border: "1px solid #ccc", background: this.state.cardiac_surgery === v ? (v === "yes" ? "#e74c3c" : "#27ae60") : "#fff", color: this.state.cardiac_surgery === v ? "#fff" : "#333", cursor: "pointer", borderRadius: v === "yes" ? "4px 0 0 4px" : "0 4px 4px 0", textTransform: "capitalize" }}
                                >{v.charAt(0).toUpperCase() + v.slice(1)}</button>
                              ))}
                            </div>
                          </div>
                          {/* Pacemaker */}
                          <div className="col-md-2" style={{ paddingRight: 6 }}>
                            <label style={{ color: "#444", fontSize: "12px", marginBottom: 4, display: "block" }}>Pacemaker</label>
                            <div className="btn-group" style={{ width: "100%" }}>
                              {[true,false].map(v => (
                                <button key={String(v)} type="button"
                                  onClick={() => this.setState({ pacemaker: v })}
                                  style={{ flex: 1, padding: "4px 0", fontSize: "12px", border: "1px solid #ccc", background: this.state.pacemaker === v ? (v ? "#e74c3c" : "#27ae60") : "#fff", color: this.state.pacemaker === v ? "#fff" : "#333", cursor: "pointer", borderRadius: v ? "4px 0 0 4px" : "0 4px 4px 0" }}
                                >{v ? "Yes" : "No"}</button>
                              ))}
                            </div>
                          </div>
                          {/* Issue Noticed */}
                          <div className="col-md-4">
                            <label style={{ color: "#444", fontSize: "12px", marginBottom: 4, display: "block" }}>Issue Noticed</label>
                            <select className="form-control input-sm" value={this.state.issueReport} onChange={(e) => this.setState({ issueReport: e.target.value })} style={{ height: 30, fontSize: "12px", padding: "2px 6px" }}>
                              <option value="NA">None</option>
                              <option value="repeat">Repeat</option>
                              <option value="low_data">Low Data</option>
                              <option value="customer_reject">Customer Reject</option>
                              <option value="battery_issue">Battery Issue</option>
                              <option value="device_issue">Device Issue</option>
                            </select>
                          </div>
                        </div>
                      </div>

                      {/* ── SECTION: Support & Assignment ── */}
                      <div style={{ background: "#f8f9fa", borderRadius: "6px", padding: "10px 14px", marginBottom: "10px" }}>
                        <div style={{ fontSize: "11px", fontWeight: 700, color: "#666", textTransform: "uppercase", letterSpacing: "0.5px", marginBottom: "8px" }}>Support & Assignment</div>
                        <div className="row" style={{ marginBottom: 6 }}>
                          {/* Support Person — from verifier list */}
                          <div className="col-md-4" style={{ paddingRight: 6 }}>
                            <div className="form-group" style={{ marginBottom: 8 }}>
                              <label style={{ color: "#444", fontSize: "12px", marginBottom: 2 }}>Support Person</label>
                              <select className="form-control input-sm" value={this.state.supportPerson} onChange={(e) => this.setState({ supportPerson: e.target.value })} style={{ height: 30, fontSize: "12px", padding: "2px 6px" }}>
                                <option value="">— None —</option>
                                {(Array.isArray(this.state.verifiers) ? this.state.verifiers : []).map((v) => (
                                  <option key={v.value} value={v.value}>{v.label}</option>
                                ))}
                              </select>
                            </div>
                          </div>
                          {/* Supported Matter */}
                          <div className="col-md-8">
                            <div className="form-group" style={{ marginBottom: 8 }}>
                              <label style={{ color: "#444", fontSize: "12px", marginBottom: 2 }}>Support Notes</label>
                              <textarea className="form-control" rows="2" value={this.state.supportedMatter} onChange={(e) => this.setState({ supportedMatter: e.target.value })} placeholder="Enter details..." style={{ fontSize: "13px", resize: "none" }} />
                            </div>
                          </div>
                        </div>
                        {/* Assign Verifier — compact multi-select */}
                        <div className="row" style={{ marginBottom: 6 }}>
                          <div className="col-md-12">
                            <label style={{ color: "#444", fontSize: "12px", marginBottom: 2, display: "block" }}>Assign Verifier</label>
                            <Select
                              isMulti
                              options={this.state.verifiers}
                              value={this.state.selectedVerifiers}
                              onChange={this.handleVerifierChange}
                              className="basic-multi-select"
                              classNamePrefix="select"
                              placeholder="Select verifiers..."
                              menuPlacement="auto"
                              maxMenuHeight={140}
                              styles={{
                                control: (base) => ({ ...base, fontSize: "12px", minHeight: 28, maxHeight: 60, overflowY: "auto" }),
                                valueContainer: (base) => ({ ...base, padding: "2px 6px", flexWrap: "wrap", maxHeight: 54, overflowY: "auto" }),
                                indicatorsContainer: (base) => ({ ...base, height: 28, alignSelf: "flex-start" }),
                                option: (provided, state) => ({ ...provided, backgroundColor: state.isSelected ? "#24333e" : state.isFocused ? "#e5e5e5" : null, color: state.isSelected ? "white" : "black", fontSize: "12px", padding: "4px 10px" }),
                                multiValue: (provided) => ({ ...provided, backgroundColor: "#24333e", margin: "1px 2px" }),
                                multiValueLabel: (provided) => ({ ...provided, color: "white", fontSize: "11px", padding: "1px 4px" }),
                                multiValueRemove: (provided) => ({ ...provided, color: "white", padding: "0 3px" }),
                              }}
                            />
                          </div>
                        </div>
                        {/* Clinical Condition + Graphs To Be Generated */}
                        <div className="row">
                          <div className="col-md-6">
                            <div className="form-group" style={{ marginBottom: 0 }}>
                              <label style={{ color: "#444", fontSize: "12px", marginBottom: 2 }}>Clinical Condition</label>
                              <textarea className="form-control" rows="2" value={this.state.clinicalCondition} onChange={(e) => this.setState({ clinicalCondition: e.target.value })} placeholder="Enter clinical condition..." style={{ fontSize: "13px", resize: "none" }} />
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="form-group" style={{ marginBottom: 0 }}>
                              <label style={{ color: "#444", fontSize: "12px", marginBottom: 2 }}>Graphs To Be Generated(no:)</label>
                              <input
                                type="text"
                                className="form-control"
                                name="graph_gen"
                                id="graph_gen_editinfo"
                                onChange={this.onChange}
                                value={this.state.graph_gen}
                                style={{ fontSize: "13px" }}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="modal-footer" style={{ padding: "10px 16px", display: "flex", justifyContent: "flex-end", gap: 8 }}>
                      <button type="button" className="btn closePopup" data-dismiss="modal" style={{ padding: "6px 20px", fontSize: "13px", background: "#f0f0f0", border: "1px solid #ccc", borderRadius: 4, color: "#444" }}>
                        Cancel
                      </button>
                      <button type="submit" className="btn btn-success" disabled={this.state.loadingEditModal} style={{ padding: "6px 24px", fontSize: "13px", background: "#27ae60", border: "none", borderRadius: 4, color: "#fff", fontWeight: 600 }}>
                        {this.state.loadingEditModal ? "Saving…" : "✓ Save Changes"}
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>

            {/* Confirmation popup removed — now handled inline in edit modal */}
            <div className="row" style={{ margin: 0 }}>
              <div className="col-sm-12" style={{ padding: "0 8px" }}>
                <div style={{ background: "#072224", borderRadius: "6px", overflow: "hidden", boxShadow: "0 2px 8px rgba(0,0,0,0.25)" }}>

                  {/* ── Compact toolbar: title + filter + search ── */}
                  <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "10px 14px", background: "#0c2e32", borderBottom: "2px solid #1e6b72" }}>
                    <span style={{ color: "#ffffff", fontWeight: 700, fontSize: "14px", letterSpacing: "0.4px" }}>
                      {this.props.mode === "Live"
                        ? "📡 Live Patients"
                        : (((this.props.location && this.props.location.search) || window.location.search || "").includes("queue=1"))
                          ? "🗂️ My Queue"
                          : "🏥 Patient List"}
                      {this.state.rows && this.state.rows.length > 0 && (
                        <span style={{ marginLeft: 8, fontSize: "11px", fontWeight: 600, color: "#ffffff", background: "#1a6a72", borderRadius: 10, padding: "2px 10px", border: "1px solid #2a9aaa" }}>
                          {this.filterRows().length} shown
                        </span>
                      )}
                    </span>
                    <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                      {/* Status filter — hidden in the Queue view (?queue=1), which is
                          already scoped to this verifier's own assigned patients. */}
                      {!((this.props.location && this.props.location.search) || window.location.search || "").includes("queue=1") && (
                        <select
                          value={this.state.statusFilter}
                          onChange={(e) => this.setState({ statusFilter: e.target.value })}
                          style={{ height: 34, fontSize: "12px", padding: "0 10px", borderRadius: 6, border: "2px solid #2eaabb", background: "#0f4a52", color: "#ffffff", outline: "none", cursor: "pointer", fontWeight: 600, boxShadow: "0 0 0 1px rgba(46,170,187,0.3)" }}
                        >
                          <option value="All">All Statuses</option>
                          <option value="Not Analyzed">Not Analyzed</option>
                          <option value="Analysis Started">Analysis Started</option>
                          <option value="Possible Stuck">Possible Stuck</option>
                          <option value="Analyze Completed">Analyze Completed</option>
                          <option value="Verification Completed">Verification Completed</option>
                          <option value="In Preparation">In Preparation</option>
                          <option value="Report Completed">Report Completed</option>
                        </select>
                      )}
                      {/* Search box */}
                      <div style={{ position: "relative", display: "flex", alignItems: "center" }}>
                        <span style={{ position: "absolute", left: 9, color: "#2eaabb", fontSize: "14px", pointerEvents: "none" }}>🔍</span>
                        <input
                          type="text"
                          placeholder="Search patient, doctor…"
                          style={{ height: 34, paddingLeft: 30, paddingRight: 10, fontSize: "12px", borderRadius: 6, border: "2px solid #2eaabb", background: "#0f4a52", color: "#ffffff", outline: "none", width: 215, fontWeight: 500, boxShadow: "0 0 0 1px rgba(46,170,187,0.3)" }}
                          value={this.state.searchQuery}
                          onChange={this.handleSearchChange}
                        />
                      </div>
                    </div>
                  </div>

                  <div style={{ padding: "0" }}>
                      <table className="table table-striped" style={{ width: "100%", tableLayout: "fixed", marginBottom: 0 }}>
                        <colgroup>
                          <col style={{ width: "5%" }} />
                          <col style={{ width: "15%" }} />
                          <col style={{ width: "10%" }} />
                          <col style={{ width: "13%" }} />
                          <col style={{ width: "18%" }} />
                          <col style={{ width: "39%" }} />
                        </colgroup>
                        <thead>
                          <tr style={{ background: "#031213" }}>
                            <th style={{ padding: "7px 8px", textAlign: "center", color: "#89a8c0", fontWeight: 600, fontSize: "11px", textTransform: "uppercase", letterSpacing: "0.6px", borderBottom: "2px solid #0c2e30", borderTop: "none" }}>SL</th>
                            <th style={{ padding: "7px 8px", textAlign: "center", color: "#89a8c0", fontWeight: 600, fontSize: "11px", textTransform: "uppercase", letterSpacing: "0.6px", borderBottom: "2px solid #0c2e30", borderTop: "none" }}>PATIENT</th>
                            <th style={{ padding: "7px 8px", textAlign: "center", color: "#89a8c0", fontWeight: 600, fontSize: "11px", textTransform: "uppercase", letterSpacing: "0.6px", borderBottom: "2px solid #0c2e30", borderTop: "none" }}>CREATED DATE</th>
                            <th style={{ padding: "7px 8px", textAlign: "center", color: "#89a8c0", fontWeight: 600, fontSize: "11px", textTransform: "uppercase", letterSpacing: "0.6px", borderBottom: "2px solid #0c2e30", borderTop: "none" }}>{localStorage.getItem("verifiertype") === "2" ? "AGE" : "DISTRIBUTOR"}</th>
                            <th style={{ padding: "7px 8px", textAlign: "center", color: "#89a8c0", fontWeight: 600, fontSize: "11px", textTransform: "uppercase", letterSpacing: "0.6px", borderBottom: "2px solid #0c2e30", borderTop: "none" }}>{localStorage.getItem("verifiertype") === "2" ? "SYMPTOMS" : "DOCTOR NAME"}</th>
                            <th style={{ padding: "7px 8px", textAlign: "center", color: "#89a8c0", fontWeight: 600, fontSize: "11px", textTransform: "uppercase", letterSpacing: "0.6px", borderBottom: "2px solid #0c2e30", borderTop: "none" }}>MONITORING</th>
                          </tr>
                        </thead>
                        <tbody>
                          {(() => {
                            // Grouped by priority band (High → Moderate →
                            // Simple → Normal). Inside every band rows are
                            // ordered oldest upload first, so patients that
                            // share a priority level queue by upload time.
                            const allRows = this.filterRows();
                            const priorityGroups = [
                              { key: 1, label: "HIGH PRIORITY", color: "#c0392b", bg: "rgba(192,57,43,0.10)",  border: "#c0392b", dot: "🔴" },
                              { key: 2, label: "MODERATE",      color: "#d68910", bg: "rgba(214,137,16,0.10)", border: "#d68910", dot: "🟡" },
                              { key: 3, label: "SIMPLE",        color: "#2980b9", bg: "rgba(41,128,185,0.10)", border: "#2980b9", dot: "🔵" },
                              { key: 4, label: "UNPRIORITISED", color: "#8095a3", bg: "rgba(128,149,163,0.08)", border: "#5b7688", dot: "⚪" },
                            ];
                            let globalIndex = 0;
                            return priorityGroups.map(group => {
                              const groupRows = allRows
                                .filter(r => (r.priorityNum || 4) === group.key)
                                .sort((a, b) => (a.uploadMs || 0) - (b.uploadMs || 0));
                              if (groupRows.length === 0) return null;
                              return (
                                <React.Fragment key={group.key}>
                                  {/* Priority Group Header */}
                                  <tr>
                                    <td colSpan={6} style={{ padding: "5px 10px", background: group.bg, borderLeft: `4px solid ${group.border}`, borderTop: "1px solid rgba(255,255,255,0.06)" }}>
                                      <span style={{ color: group.color, fontWeight: 700, fontSize: "11px", textTransform: "uppercase", letterSpacing: "0.8px" }}>
                                        {group.dot} {group.label}
                                      </span>
                                      <span style={{ fontSize: "11px", color: "#888", marginLeft: 8 }}>
                                        {groupRows.length} patient{groupRows.length !== 1 ? "s" : ""}
                                      </span>
                                    </td>
                                  </tr>
                                  {groupRows.map((row, rowIndex) => {
                                    const displayIndex = ++globalIndex;
                                    return (
                                <React.Fragment key={row._id || rowIndex}>
                              <tr>
                                <td style={{ textAlign: "center", verticalAlign: "middle" }}>{displayIndex}</td>
                                <td
                                  onClick={() => this.navigateToPatient(row)}
                                  style={{ cursor: "pointer", verticalAlign: "middle", textAlign: "center" }}
                                >
                                  <div style={{ fontWeight: 700, fontSize: "13px", lineHeight: 1.3 }}>{row.patientId}</div>
                                  <div style={{ fontSize: "14px", fontWeight: 500, opacity: 0.9, marginTop: "2px" }}>{row.name}</div>
                                  {row.block && (
                                    <div
                                      title="Your assigned portion(s) of this recording"
                                      style={{
                                        display: "flex", flexWrap: "wrap",
                                        justifyContent: "center", gap: "3px",
                                        marginTop: "3px",
                                      }}
                                    >
                                      {String(row.block)
                                        .split(",")
                                        .map((s) => s.trim())
                                        .filter(Boolean)
                                        .map((label, i) => (
                                          <span
                                            key={i}
                                            style={{
                                              display: "inline-block",
                                              padding: "1px 6px", fontSize: "9px", fontWeight: 700,
                                              textTransform: "uppercase", letterSpacing: "0.3px",
                                              color: "#1a6fa3", background: "#e8f4fd",
                                              border: "1px solid #a9d6f5", borderRadius: "8px",
                                              whiteSpace: "nowrap",
                                            }}
                                          >
                                            {label}
                                          </span>
                                        ))}
                                    </div>
                                  )}
                                  {row.confirmation === "Live" && <LiveTag />}
                                  {row.confirmation !== "Live" && this.isRemoteMode(row) && (
                                    <span
                                      title="The app is in remote / live mode. If this is a live patient, set Confirmation to Live (Edit Patient)."
                                      style={{ display: "inline-block", marginTop: 3, fontSize: "10px", fontWeight: 700, color: "#fff", background: "#8e44ad", borderRadius: 10, padding: "1px 8px", letterSpacing: "0.5px" }}
                                    >
                                      📡 REMOTE
                                    </span>
                                  )}
                                </td>
                                <td onClick={() => this.navigateToPatient(row)} style={{ cursor: "pointer", verticalAlign: "middle" }}>
                                  {row.added_date}
                                </td>
                                <td style={{ verticalAlign: "middle" }}>
                                  {localStorage.getItem("verifiertype") === "2"
                                    ? row.DOB
                                      ? (() => {
                                        const dob = new Date(row.DOB);
                                        const today = new Date();
                                        let age = today.getFullYear() - dob.getFullYear();
                                        const m = today.getMonth() - dob.getMonth();
                                        if (m < 0 || (m === 0 && today.getDate() < dob.getDate())) {
                                          age--;
                                        }
                                        return age;
                                      })()
                                      : "NA"
                                    : row.distributor}
                                </td>
                                <td style={{ verticalAlign: "middle" }}>
                                  {localStorage.getItem("verifiertype") === "2"
                                    ? row.indication || "NA" : row.doctor_name}
                                </td>
                                <td style={{ verticalAlign: "top" }}>{row.monitoring_duration}</td>
                              </tr>
                              {this.state.patientProgress[row._id] &&
                                this.state.patientProgress[row._id].isActive && (
                                  <tr>
                                    <td colSpan={6}>
                                      <div
                                        style={{
                                          height: "30px",
                                          width: "100%",
                                          backgroundColor: "#e0e0e0",
                                          borderRadius: "5px",
                                          overflow: "hidden",
                                          position: "relative",
                                          marginTop: "8px",
                                          marginBottom: "8px",
                                        }}
                                      >
                                        <div
                                          style={{
                                            height: "100%",
                                            width: `${this.state.patientProgress[row._id].progress}%`,
                                            backgroundColor:
                                              this.state.patientProgress[row._id].progress >= 80
                                                ? "#ff6b6b"
                                                : this.state.patientProgress[row._id].progress >= 50
                                                  ? "#ffa500"
                                                  : "#4caf50",
                                            transition: "width 0.3s ease",
                                            position: "absolute",
                                            top: 0,
                                            left: 0,
                                          }}
                                        ></div>

                                        <div
                                          style={{
                                            position: "absolute",
                                            top: 0,
                                            left: 0,
                                            height: "100%",
                                            width: "100%",
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            fontWeight: "bold",
                                            color: "#000",
                                            fontSize: "14px",
                                          }}
                                        >
                                          {this.state.patientProgress[row._id].progress}%
                                        </div>
                                      </div>
                                    </td>
                                  </tr>
                                )}
                                    </React.Fragment>
                                    );
                                  })}
                                </React.Fragment>
                              );
                            });
                          })()}
                        </tbody>
                      </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <EcgStripsModal
          userid={this.state.stripsUserid}
          onClose={() => this.setState({ stripsUserid: null })}
        />
      </div>
    );
  }
}

export default PatientList;
